import { initWebVitalsTelemetry } from "./web-vitals";
import { csrfHeaders, getCsrfToken } from "./csrf";
import { readJsonOrThrow } from "./http-errors";
import { getBrowserInfo } from "./browser-info";
import { toast } from "./toast";
import { trackEvent } from "./ga-events";
import { writeClipboardText } from "./clipboard";

// ── Intelligence signal recording (fire-and-forget, never blocks UI) ──
function recordIntelligenceSignal(signalType, card) {
    if (!card) return;
    var itemId = card.getAttribute('data-item-id');
    if (!itemId) return;
    var senderEmail = card.getAttribute('data-sender-email') || undefined;
    var category = card.getAttribute('data-category') || undefined;
    fetch('/api/intelligence/signal', {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify({ itemId: itemId, signalType: signalType, senderEmail: senderEmail, category: category })
    }).catch(function () { /* non-critical */ });
}

window.openSupport = function () {
    var overlay = document.getElementById('support-overlay');
    if (!overlay) return;
    overlay.classList.remove('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { overlay.classList.add('show'); }, 10);
    var msgEl = document.getElementById('supportFormMessage');
    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; }
    setTimeout(function () {
        var ta = document.getElementById('supportMessage');
        if (ta) ta.focus();
    }, 200);
};

window.closeSupport = function () {
    var overlay = document.getElementById('support-overlay');
    if (!overlay) return;
    overlay.classList.remove('show');
    overlay.setAttribute('aria-hidden', 'true');
    setTimeout(function () { overlay.classList.add('hidden'); }, 300);
};

function openDeleteAccount() {
    var overlay = document.getElementById('delete-account-overlay');
    if (!overlay) return;
    var input = document.getElementById('delete-confirmation-modal');
    var msgEl = document.getElementById('delete-account-form-message');
    if (input) input.value = '';
    if (msgEl) {
        msgEl.textContent = '';
        msgEl.hidden = true;
        msgEl.classList.remove('success', 'error');
    }
    overlay.classList.remove('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { overlay.classList.add('show'); }, 10);
    setTimeout(function () {
        if (input && typeof input.focus === 'function') {
            input.focus();
        }
    }, 200);
    trackEvent('account_delete_modal_opened', {});
}

function closeDeleteAccount() {
    var overlay = document.getElementById('delete-account-overlay');
    if (!overlay) return;
    overlay.classList.remove('show');
    overlay.setAttribute('aria-hidden', 'true');
    setTimeout(function () { overlay.classList.add('hidden'); }, 300);
}

function showSupportMessage(text, isError) {
    var el = document.getElementById('supportFormMessage');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    el.classList.remove('success', 'error');
    el.classList.add(isError ? 'error' : 'success');
}

window.submitSupport = function () {
    var messageEl = document.getElementById('supportMessage');
    var message = messageEl ? messageEl.value.trim() : '';
    if (!message) {
        showSupportMessage('Please enter a message.', true);
        return;
    }
    var nameEl = document.getElementById('supportName');
    var emailEl = document.getElementById('supportEmail');
    var name = (nameEl && nameEl.value) ? nameEl.value.trim() : '';
    var email = (emailEl && emailEl.value) ? emailEl.value.trim() : '';
    if (nameEl && emailEl) {
        if (!name || !email) {
            showSupportMessage('Please enter your name and email.', true);
            return;
        }
    }
    var btn = document.getElementById('supportSubmitBtn');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    showSupportMessage('Sending…', false);
    var body = { message: message, source: 'support-popup', browserInfo: getBrowserInfo() };
    if (name) body.name = name;
    if (email) body.email = email;
    fetch('/Contact/Send', {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify(body)
    })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
            if (r.ok && r.data.success) {
                showSupportMessage(r.data.message || 'Thanks! Your message was sent.', false);
                toast.success('Message sent! We\'ll get back to you soon.');
                trackEvent('support_message_sent', {});
                if (messageEl) messageEl.value = '';
                if (nameEl) nameEl.value = '';
                if (emailEl) emailEl.value = '';
                setTimeout(function () {
                    closeSupport();
                }, 1500);
            } else {
                var errMsg = (r.data && r.data.error) || 'Something went wrong. Please try again.';
                showSupportMessage(errMsg, true);
                toast.error(errMsg);
            }
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        })
        .catch(function () {
            showSupportMessage('Network error. Please try again.', true);
            toast.error('Network error. Please try again.');
            if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        });
};

// Escape key closes overlays
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var deleteOverlay = document.getElementById('delete-account-overlay');
    if (deleteOverlay && deleteOverlay.classList.contains('show')) {
        closeDeleteAccount();
        trackEvent('account_delete_modal_cancelled', {});
        return;
    }
    var overlay = document.getElementById('support-overlay');
    if (overlay && overlay.classList.contains('show')) {
        closeSupport();
    }
});

// Bind support overlay UI (CSP-safe: no inline handlers)
function bindSupportOverlay() {
    document.querySelectorAll('.js-open-support').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); openSupport(); });
    });
    document.querySelectorAll('.js-close-support').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); closeSupport(); });
    });
    var submitBtn = document.getElementById('supportSubmitBtn');
    if (submitBtn) submitBtn.addEventListener('click', function (e) { e.preventDefault(); submitSupport(); });
}

function bindDeleteAccountOverlay() {
    var openButtons = document.querySelectorAll('.js-open-delete-account');
    openButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            openDeleteAccount();
        });
    });

    document.querySelectorAll('.js-close-delete-account').forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            closeDeleteAccount();
            trackEvent('account_delete_modal_cancelled', {});
        });
    });

    var deleteForm = document.getElementById('delete-account-form');
    if (deleteForm) {
        deleteForm.addEventListener('submit', function (e) {
            var input = document.getElementById('delete-confirmation-modal');
            var msgEl = document.getElementById('delete-account-form-message');
            var confirmation = input && input.value ? input.value.trim() : '';
            if (confirmation !== 'DELETE') {
                e.preventDefault();
                if (msgEl) {
                    msgEl.textContent = 'Type DELETE to confirm account deletion.';
                    msgEl.classList.remove('success');
                    msgEl.classList.add('error');
                    msgEl.hidden = false;
                }
                if (input && typeof input.focus === 'function') {
                    input.focus();
                }
            }
        });
    }
}

function bindDataExportTracking() {
    var btn = document.querySelector('.js-request-data-export');
    if (btn) {
        btn.addEventListener('click', function () {
            trackEvent('data_export_requested', {});
        });
    }
}

function initAnalyticsTracking() {
    var section = document.querySelector('[data-analytics-period]');
    if (!section) return;
    var period = parseInt(section.getAttribute('data-analytics-period'), 10) || 30;
    trackEvent('view_analytics', { period: period });
}

// ═══════════════════════════════════════════════════════════════
// Settings: AJAX form submission
// ═══════════════════════════════════════════════════════════════

function initSettingsAjaxForms() {
    document.querySelectorAll('form.settings-form').forEach(function (form) {
        if (form.hasAttribute('data-settings-native')) return;
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            var submitBtn = form.querySelector('button[type="submit"]');
            if (submitBtn && submitBtn.disabled) return;
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.classList.add('is-loading');
            }

            var token = (form.querySelector('input[name="__RequestVerificationToken"]') || {}).value || '';
            var headers = { 'X-Requested-With': 'XMLHttpRequest' };
            if (token) headers['X-CSRF-TOKEN'] = token;

            fetch(form.action, {
                method: 'POST',
                headers: headers,
                body: new FormData(form),
                credentials: 'same-origin'
            })
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.json();
            })
            .then(function (data) {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.classList.remove('is-loading');
                }
                var msg = data.message || (data.success ? 'Saved' : 'Something went wrong.');
                showSettingsStatus(form, msg, !data.success);
                applySettingsAjaxData(data);
                if (data.success) {
                    toast.success(msg);
                    trackEvent('settings_saved', { section: guessSectionFromForm(form) });
                    // Fire specific event for auto-add toggle changes
                    var autoAddCheckbox = form.querySelector('#auto-add-calendar-toggle');
                    if (autoAddCheckbox) {
                        trackEvent('calendar_auto_add_toggled', { enabled: autoAddCheckbox.checked });
                    }
                } else {
                    toast.error(msg);
                }
            })
            .catch(function () {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.classList.remove('is-loading');
                }
                var msg = "Couldn't save. Please try again.";
                showSettingsStatus(form, msg, true);
                toast.error(msg);
            });
        });
    });
}

function showSettingsStatus(form, message, isError) {
    var el = form.querySelector('.settings-status');
    if (!el) {
        el = document.createElement('p');
        el.setAttribute('aria-live', 'polite');
        form.appendChild(el);
    }
    el.className = isError ? 'settings-status settings-status-error' : 'settings-status';
    if (isError) el.setAttribute('role', 'alert');
    else el.removeAttribute('role');
    el.textContent = message;
    el.hidden = false;
}

function applySettingsAjaxData(data) {
    if (!data || typeof data !== 'object') return;
    if (data.reload) {
        location.reload();
        return;
    }
    if (data.displayName) {
        applyDisplayNameUi(data.displayName);
    }
    if (data.timezone) {
        applyTimezoneUi(data.timezone);
    }
    if (data.calendarPreference) {
        applyCalendarPreferenceUi(data.calendarPreference);
    }
    if (data.dashboardLayout) {
        applyDashboardLayoutUi(data.dashboardLayout);
    }
    if (data.digestSchedule) {
        applyDigestScheduleUi(data.digestSchedule);
    }
}

function applyDisplayNameUi(displayName) {
    if (!displayName || typeof displayName !== 'object') return;

    updateTextForAll('[data-profile-headline]', displayName.profileHeadline);
    updateTextForAll('[data-user-avatar-initial]', displayName.avatarInitial);

    document.querySelectorAll('[data-display-name-badge]').forEach(function (el) {
        el.textContent = displayName.displayName || '';
        el.hidden = displayName.hasDisplayName !== true;
    });

    document.querySelectorAll('[data-user-display-name]').forEach(function (el) {
        el.textContent = displayName.displayName || '';
        el.hidden = displayName.hasDisplayName !== true;
    });

    document.querySelectorAll('[data-account-menu-trigger]').forEach(function (el) {
        if (displayName.accountMenuLabel) {
            el.setAttribute('aria-label', displayName.accountMenuLabel);
        }
    });
}

function applyTimezoneUi(timezone) {
    if (!timezone || typeof timezone !== 'object') return;

    updateTextForAll('[data-timezone-display]', timezone.display);
    updatePrefixedTextForAll('[data-timezone-summary]', 'Timezone: ', timezone.display);
}

function applyCalendarPreferenceUi(calendarPreference) {
    if (!calendarPreference || typeof calendarPreference !== 'object') return;

    updateTextForAll('[data-calendar-provider-label]', calendarPreference.label);
    updatePrefixedTextForAll('[data-calendar-summary]', 'Calendar: ', calendarPreference.label);
}

function applyDashboardLayoutUi(dashboardLayout) {
    if (!dashboardLayout || typeof dashboardLayout !== 'object') return;

    updatePrefixedTextForAll('[data-dashboard-layout-current]', 'Current: ', dashboardLayout.label);

    if (typeof dashboardLayout.variant === 'string') {
        document.querySelectorAll('input[name="dashboardUiVariant"]').forEach(function (input) {
            input.checked = input.value === dashboardLayout.variant;
        });

        document.querySelectorAll('[data-dashboard-layout-selected-state]').forEach(function (el) {
            el.hidden = el.getAttribute('data-dashboard-layout-selected-state') !== dashboardLayout.variant;
        });
    }
}

function applyDigestScheduleUi(digestSchedule) {
    if (!digestSchedule || typeof digestSchedule !== 'object') return;

    updateTextForAll('[data-digest-schedule-summary]', digestSchedule.summary);
    updateTextForAll('[data-digest-schedule-mode]', digestSchedule.scheduleModeLabel);
    updateTextForAll('[data-digest-next-short]', digestSchedule.heroNextText);

    if (typeof digestSchedule.localTime === 'string') {
        var timeInput = document.getElementById('digest-time-input');
        if (timeInput) {
            timeInput.value = digestSchedule.localTime;
        }
    }

    if (typeof digestSchedule.dayOfWeek === 'number') {
        var daySelect = document.getElementById('digest-day-select');
        if (daySelect) {
            daySelect.value = String(digestSchedule.dayOfWeek);
        }
    }

    if (Array.isArray(digestSchedule.daysOfWeek)) {
        document.querySelectorAll('input[name="daysOfWeek"][type="checkbox"]').forEach(function (input) {
            var inputValue = parseInt(input.value, 10);
            input.checked = digestSchedule.daysOfWeek.indexOf(inputValue) >= 0;
        });
    }

    var hasValidTimezone = digestSchedule.hasValidTimezone === true;
    document.querySelectorAll('[data-digest-valid-timezone-help]').forEach(function (el) {
        el.hidden = !hasValidTimezone;
    });
    document.querySelectorAll('[data-digest-missing-timezone-warning]').forEach(function (el) {
        el.hidden = hasValidTimezone;
    });
    document.querySelectorAll('[data-digest-save-button]').forEach(function (el) {
        el.disabled = !hasValidTimezone;
    });

    var hasNextDigest = digestSchedule.hasNextDigest === true;
    var nextDigestFullText = digestSchedule.nextDigestFullText || '';
    var timezone = digestSchedule.timezone || '';
    var hasTimezone = hasNextDigest && Boolean(timezone);

    document.querySelectorAll('[data-digest-next-full]').forEach(function (el) {
        var fullText = el.querySelector('[data-digest-next-full-text]');
        if (fullText) {
            fullText.textContent = nextDigestFullText;
        }

        var timezoneWrap = el.querySelector('[data-digest-next-full-timezone]');
        if (timezoneWrap) {
            timezoneWrap.hidden = !hasTimezone;

            var timezoneText = timezoneWrap.querySelector('[data-digest-timezone]');
            if (timezoneText) {
                timezoneText.textContent = hasTimezone ? timezone : '';
            }
        }

        el.hidden = !hasNextDigest;
    });
}

// Nearest-quarter-hour, mirrors TimeOfDayParser.SnapToQuarterHour server-side.
function snapTimeStringToQuarterHour(value) {
    var match = /^(\d{2}):(\d{2})$/.exec(value || '');
    if (!match) return value;

    var totalMinutes = parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
    var remainder = totalMinutes % 15;
    var snapped = remainder * 2 < 15 ? totalMinutes - remainder : totalMinutes + (15 - remainder);
    if (snapped > 23 * 60 + 45) snapped = 23 * 60 + 45;

    var hh = String(Math.floor(snapped / 60)).padStart(2, '0');
    var mm = String(snapped % 60).padStart(2, '0');
    return hh + ':' + mm;
}

// Self-corrects the delivery-time input to the nearest :00/:15/:30/:45 before
// submit, instead of letting the browser's native step-mismatch bubble (Chrome)
// or an off-grid value (Firefox arrow-key stepping) reach the save button.
function initDigestTimeSnapping() {
    var timeInput = document.getElementById('digest-time-input');
    if (!timeInput) return;

    timeInput.addEventListener('change', function () {
        if (!timeInput.value) return;
        timeInput.value = snapTimeStringToQuarterHour(timeInput.value);
    });
}

function updateTextForAll(selector, text) {
    if (typeof text !== 'string') return;

    document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = text;
    });
}

function updatePrefixedTextForAll(selector, prefix, text) {
    if (typeof text !== 'string') return;

    document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = prefix + text;
    });
}

function guessSectionFromForm(form) {
    var action = (form.getAttribute('action') || '').split('?')[0] || '';
    return action.split('/').filter(Boolean).pop() || 'settings';
}

// Auto-submit forms when their inputs change (used by toggle switches).
function initAutoSubmitToggles() {
    document.querySelectorAll('form[data-auto-submit]').forEach(function (form) {
        form.addEventListener('change', function () {
            form.requestSubmit();
        });
    });
}

// ── Calendar connection test: step-by-step create → update → delete via overflow menu ──
function initCalendarTestButtons() {
    var STORAGE_KEY = 'stackora_cal_test_';

    // ── sessionStorage ──
    function storeKey(connId) { return STORAGE_KEY + connId; }
    function saveEventState(connId, state) {
        try { sessionStorage.setItem(storeKey(connId), JSON.stringify(state)); } catch (_) {}
    }
    function loadEventState(connId) {
        try { var r = sessionStorage.getItem(storeKey(connId)); return r ? JSON.parse(r) : null; } catch (_) { return null; }
    }
    function clearEventState(connId) {
        try { sessionStorage.removeItem(storeKey(connId)); } catch (_) {}
    }

    // ── Close the overflow menu for any element inside it (replicates closeOverflowMenu) ──
    function closeMenuOf(el) {
        var wrap = el.closest('.dc-overflow-wrap');
        if (!wrap) return;
        var menu = wrap.querySelector('.dc-overflow-menu');
        var trigger = wrap.querySelector('.js-dc-overflow');
        if (menu) {
            menu.setAttribute('aria-hidden', 'true');
            menu.setAttribute('hidden', '');
            menu.classList.remove('dc-overflow-menu--open-up');
            menu.style.maxHeight = '';
            menu.style.overflowY = '';
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    // ── Trigger: pending dot and in-flight loading ──
    function setTriggerPending(menu, pending) {
        var wrap = menu.closest('.dc-overflow-wrap');
        var trigger = wrap && wrap.querySelector('.settings-test-trigger');
        if (trigger) trigger.classList.toggle('settings-test-trigger--pending', !!pending);
    }
    function setTriggerLoading(menu, loading) {
        var wrap = menu.closest('.dc-overflow-wrap');
        var trigger = wrap && wrap.querySelector('.settings-test-trigger');
        if (trigger) trigger.classList.toggle('is-loading', !!loading);
    }

    // ── aria-disabled helpers ──
    function enableItem(menu, selector) {
        var item = menu.querySelector(selector);
        if (item) item.removeAttribute('aria-disabled');
    }
    function disableItem(menu, selector) {
        var item = menu.querySelector(selector);
        if (item) item.setAttribute('aria-disabled', 'true');
    }

    // ── Text mutation that preserves the SVG icon ──
    function setItemText(item, text) {
        var span = item.querySelector('span');
        if (span) span.textContent = text;
    }

    // ── Apply / reset all menu state from a stored event record ──
    function applyStateToMenu(menu, state) {
        var hasEvent = !!(state && state.eventId);
        if (hasEvent) {
            menu.setAttribute('data-event-id', state.eventId);
            menu.setAttribute('data-calendar-id', state.calendarId || '');
            menu.setAttribute('data-event-connection-id', state.eventConnectionId || '');
            enableItem(menu, '.js-cal-test-update');
            enableItem(menu, '.js-cal-test-delete');
            var divider = menu.querySelector('.js-cal-test-reset-divider');
            var resetBtn = menu.querySelector('.js-cal-test-reset');
            if (divider) divider.removeAttribute('hidden');
            if (resetBtn) resetBtn.removeAttribute('hidden');
        } else {
            menu.removeAttribute('data-event-id');
            menu.removeAttribute('data-calendar-id');
            menu.removeAttribute('data-event-connection-id');
            disableItem(menu, '.js-cal-test-update');
            disableItem(menu, '.js-cal-test-delete');
            var divider2 = menu.querySelector('.js-cal-test-reset-divider');
            var resetBtn2 = menu.querySelector('.js-cal-test-reset');
            if (divider2) divider2.setAttribute('hidden', '');
            if (resetBtn2) resetBtn2.setAttribute('hidden', '');
        }
        setTriggerPending(menu, hasEvent);
    }

    // ── Fetch helper ──
    // Accept: application/json is required, not cosmetic — it is the signal every JSON-vs-HTML
    // branch on the server keys off. Without it an expired session and a lapsed entitlement both
    // come back as a followed 302 to an HTML page, so the failure is indistinguishable from a
    // dropped connection.
    function calTestFetch(url, body) {
        var headers = csrfHeaders();
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        headers['Accept'] = 'application/json';
        return fetch(url, {
            method: 'POST',
            headers: headers,
            body: body || '',
            credentials: 'same-origin'
        }).then(function (res) { return readJsonOrThrow(res, 'Could not complete that request. Try again.'); });
    }

    // Show what actually went wrong. Only a rejected fetch() — offline, DNS, aborted — has no
    // userMessage, and for that the connection wording is the accurate one.
    function calTestErrorMessage(err) {
        return (err && err.userMessage) || 'Request failed — check your connection and try again.';
    }

    // ── Restore state from sessionStorage on page load ──
    document.querySelectorAll('[data-cal-test-menu]').forEach(function (menu) {
        var connId = menu.getAttribute('data-connection-id');
        if (!connId) return;
        applyStateToMenu(menu, loadEventState(connId));
    });

    // ── Unified click handler for all test actions ──
    document.addEventListener('click', function (e) {
        // Silently absorb clicks on aria-disabled items
        var anyItem = e.target.closest('.dc-overflow-item');
        if (anyItem && anyItem.getAttribute('aria-disabled') === 'true') {
            e.preventDefault();
            return;
        }

        // ── Create ──
        var createBtn = e.target.closest('.js-cal-test-create');
        if (createBtn && !createBtn.hasAttribute('data-busy')) {
            var menu = createBtn.closest('[data-cal-test-menu]');
            if (!menu) return;
            var provider = menu.getAttribute('data-provider');
            var connId = menu.getAttribute('data-connection-id');

            closeMenuOf(createBtn);
            menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.setAttribute('data-busy', ''); });
            setTriggerLoading(menu, true);
            setItemText(createBtn, 'Creating…');

            calTestFetch('/settings/calendar/test/' + encodeURIComponent(provider) + '/' + encodeURIComponent(connId) + '/create')
                .then(function (data) {
                    setItemText(createBtn, 'Create test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);

                    if (data.success) {
                        if (data.eventId) {
                            var state = { eventId: data.eventId, calendarId: data.calendarId || '', eventConnectionId: data.connectionId || '' };
                            saveEventState(connId, state);
                            applyStateToMenu(menu, state);
                        }
                        toast.success('Test event created.', {
                            subtitle: 'Open your calendar to verify — it may take a moment to appear.',
                            duration: 10000,
                            action: data.eventUrl ? { label: 'Open event →', url: data.eventUrl } : null
                        });
                        trackEvent('calendar_test_create', { provider: provider, result: 'success' });
                    } else {
                        toast.error(data.message || 'Could not create test event.', { subtitle: 'Try reconnecting your calendar.' });
                        trackEvent('calendar_test_create', { provider: provider, result: 'failure' });
                    }
                })
                .catch(function (err) {
                    setItemText(createBtn, 'Create test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);
                    toast.error(calTestErrorMessage(err));
                });
            return;
        }

        // ── Update ──
        var updateBtn = e.target.closest('.js-cal-test-update');
        if (updateBtn && !updateBtn.hasAttribute('data-busy') && updateBtn.getAttribute('aria-disabled') !== 'true') {
            var menu = updateBtn.closest('[data-cal-test-menu]');
            if (!menu) return;
            var provider = menu.getAttribute('data-provider');
            var connId = menu.getAttribute('data-connection-id');
            var eventId = menu.getAttribute('data-event-id');
            if (!eventId) { toast.error('No test event found — create one first.'); return; }

            closeMenuOf(updateBtn);
            menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.setAttribute('data-busy', ''); });
            setTriggerLoading(menu, true);
            setItemText(updateBtn, 'Updating…');

            var body = 'eventId=' + encodeURIComponent(eventId)
                + '&calendarId=' + encodeURIComponent(menu.getAttribute('data-calendar-id') || '')
                + '&eventConnectionId=' + encodeURIComponent(menu.getAttribute('data-event-connection-id') || '');
            calTestFetch('/settings/calendar/test/' + encodeURIComponent(provider) + '/' + encodeURIComponent(connId) + '/update', body)
                .then(function (data) {
                    setItemText(updateBtn, 'Update test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);

                    if (data.success) {
                        toast.success('Test event updated.', {
                            subtitle: 'Open your calendar — the title and time have changed.',
                            duration: 9000
                        });
                        trackEvent('calendar_test_update', { provider: provider, result: 'success' });
                    } else {
                        toast.error(data.message || 'Update failed.', { subtitle: 'If you deleted the event manually, use "Reset test state" to start over.' });
                        trackEvent('calendar_test_update', { provider: provider, result: 'failure' });
                    }
                })
                .catch(function (err) {
                    setItemText(updateBtn, 'Update test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);
                    toast.error(calTestErrorMessage(err));
                });
            return;
        }

        // ── Delete ──
        var deleteBtn = e.target.closest('.js-cal-test-delete');
        if (deleteBtn && !deleteBtn.hasAttribute('data-busy') && deleteBtn.getAttribute('aria-disabled') !== 'true') {
            var menu = deleteBtn.closest('[data-cal-test-menu]');
            if (!menu) return;
            var provider = menu.getAttribute('data-provider');
            var connId = menu.getAttribute('data-connection-id');
            var eventId = menu.getAttribute('data-event-id');
            if (!eventId) { toast.error('No test event found — create one first.'); return; }

            closeMenuOf(deleteBtn);
            menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.setAttribute('data-busy', ''); });
            setTriggerLoading(menu, true);
            setItemText(deleteBtn, 'Deleting…');

            var body = 'eventId=' + encodeURIComponent(eventId)
                + '&calendarId=' + encodeURIComponent(menu.getAttribute('data-calendar-id') || '')
                + '&eventConnectionId=' + encodeURIComponent(menu.getAttribute('data-event-connection-id') || '');
            calTestFetch('/settings/calendar/test/' + encodeURIComponent(provider) + '/' + encodeURIComponent(connId) + '/delete', body)
                .then(function (data) {
                    setItemText(deleteBtn, 'Delete test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);

                    if (data.success) {
                        clearEventState(connId);
                        applyStateToMenu(menu, null);
                        toast.success('Test event deleted.', {
                            subtitle: 'It may take a moment to clear from your calendar view.',
                            duration: 8000
                        });
                        trackEvent('calendar_test_delete', { provider: provider, result: 'success' });
                    } else {
                        toast.error(data.message || 'Delete failed.', { subtitle: 'If the event is already gone, use "Reset test state" to start over.' });
                        trackEvent('calendar_test_delete', { provider: provider, result: 'failure' });
                    }
                })
                .catch(function (err) {
                    setItemText(deleteBtn, 'Delete test event');
                    menu.querySelectorAll('.dc-overflow-item').forEach(function (i) { i.removeAttribute('data-busy'); });
                    setTriggerLoading(menu, false);
                    toast.error(calTestErrorMessage(err));
                });
            return;
        }

        // ── Reset (no network call — clears stale sessionStorage state) ──
        var resetBtn = e.target.closest('.js-cal-test-reset');
        if (resetBtn && !resetBtn.hasAttribute('data-busy')) {
            var menu = resetBtn.closest('[data-cal-test-menu]');
            if (!menu) return;
            var connId = menu.getAttribute('data-connection-id');
            closeMenuOf(resetBtn);
            clearEventState(connId);
            applyStateToMenu(menu, null);
            toast.info('Test state reset — you can create a new test event.');
        }
    });
}

function initSubscriptionSettings() {
    // ── Segmented toggle: switch digest mode via AJAX ──
    document.addEventListener('click', function (e) {
        var toggle = e.target.closest('.js-sub-toggle');
        if (!toggle) return;

        var group = toggle.closest('.js-sub-toggle-group');
        var row = toggle.closest('.settings-sub-row');
        if (!group || !row) return;

        var mode = toggle.getAttribute('data-mode');
        var senderEmail = row.getAttribute('data-sender-email');
        if (!mode || !senderEmail) return;

        // Already active?
        if (toggle.getAttribute('aria-checked') === 'true') return;

        // Optimistic UI update
        group.querySelectorAll('.js-sub-toggle').forEach(function (b) {
            var isThis = b === toggle;
            b.classList.toggle('settings-sub-toggle--active', isThis);
            b.setAttribute('aria-checked', isThis ? 'true' : 'false');
        });
        toggle.classList.add('settings-sub-toggle--saving');

        fetch('/settings/subscription-preference', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ senderEmail: senderEmail, digestMode: mode })
        })
        .then(function (res) {
            if (!res.ok) throw new Error();
            return res.json();
        })
        .then(function (data) {
            toggle.classList.remove('settings-sub-toggle--saving');
            if (data.success) {
                var modeLabels = { show: 'Full card', headline: 'Headline only', skip: 'Skipped', not_subscription: 'Regular mail (not a subscription)' };
                toast.success('Preference updated to "' + (modeLabels[mode] || mode) + '"');
                trackEvent('settings_saved', { section: 'subscriptions', mode: mode });
            } else {
                toast.error(data.message || 'Could not save preference.');
            }
        })
        .catch(function () {
            toggle.classList.remove('settings-sub-toggle--saving');
            toast.error('Could not save preference. Please try again.');
        });
    });

    // ── Search / filter ──
    var searchInput = document.querySelector('.js-sub-search');
    if (searchInput) {
        var debounceTimer;
        searchInput.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                var query = searchInput.value.toLowerCase().trim();
                document.querySelectorAll('.settings-sub-row').forEach(function (row) {
                    var name = (row.getAttribute('data-sender-name') || '').toLowerCase();
                    var email = (row.getAttribute('data-sender-email') || '').toLowerCase();
                    var visible = !query || name.indexOf(query) !== -1 || email.indexOf(query) !== -1;
                    row.style.display = visible ? '' : 'none';
                });
            }, 150);
        });
    }
}

function bindDashboardCopyButtons(root) {
    (root || document).querySelectorAll('.dash-copy-btn[data-copy]').forEach(function (btn) {
        if (btn.dataset.copyBound === 'true') return;
        btn.dataset.copyBound = 'true';

        btn.addEventListener('click', function () {
            var text = btn.getAttribute('data-copy') || '';
            if (!text) return;

            var lbl = btn.querySelector('.dash-copy-label');
            var originalLabel = lbl ? lbl.textContent : 'Copy';
            var analyticsEvent = btn.getAttribute('data-copy-event') || '';
            var analyticsPayload = btn.getAttribute('data-copy-payload') || '';

            writeClipboardText(text).then(function () {
                if (lbl) lbl.textContent = 'Copied!';
                btn.classList.add('copied');
                if (analyticsEvent) {
                    var payload = {};
                    if (analyticsPayload) {
                        try { payload = JSON.parse(analyticsPayload); } catch (e) { payload = {}; }
                    }
                    trackEvent(analyticsEvent, payload);
                } else {
                    var copyLocation = btn.closest('.dash-fwd--hero')
                        ? 'dashboard_hero'
                        : (btn.closest('.dash-fwd--sidebar') ? 'dashboard_sidebar' : (btn.closest('.dc') ? 'digest_card' : 'other'));
                    trackEvent('copy_forwarding_address', { copy_location: copyLocation });
                }
                if (window.Stackora && window.Stackora.toast) {
                    window.Stackora.toast.success('Copied to clipboard', { duration: 2000 });
                }
                setTimeout(function () {
                    if (lbl) lbl.textContent = originalLabel;
                    btn.classList.remove('copied');
                }, 2000);
            }).catch(function () {
                if (window.Stackora && window.Stackora.toast) {
                    window.Stackora.toast.error('Could not copy to clipboard', { duration: 3500 });
                }
            });
        });
    });
}


function bindMessageLinkCopyButtons(root) {
    (root || document).querySelectorAll('.msg-view__link-copy[data-copy]').forEach(function (btn) {
        if (btn.dataset.copyBound === 'true') return;
        btn.dataset.copyBound = 'true';

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var text = btn.getAttribute('data-copy') || '';
            if (!text) return;

            var lbl = btn.querySelector('.msg-view__link-copy-label');
            var originalLabel = lbl ? lbl.textContent : 'Copy';

            function onCopied() {
                if (lbl) lbl.textContent = 'Copied';
                btn.classList.add('is-copied');
                btn.setAttribute('aria-label', 'Copied');
                trackEvent('message_link_copied', { context: 'message_reader' });
                if (window.Stackora && window.Stackora.toast) {
                    window.Stackora.toast.success('Link copied', { duration: 2000 });
                }
                setTimeout(function () {
                    if (lbl) lbl.textContent = originalLabel;
                    btn.classList.remove('is-copied');
                    btn.setAttribute('aria-label', 'Copy link');
                }, 2000);
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(onCopied);
                return;
            }

            // Fallback for older browsers / permission edge cases.
            var ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.top = '-9999px';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try {
                if (document.execCommand('copy')) onCopied();
            } finally {
                document.body.removeChild(ta);
            }
        });
    });
}

function bindDashboardCalendarFlyouts(root) {
    (root || document).querySelectorAll('.js-dc-cal-add').forEach(function (btn) {
        if (btn.dataset.calBound === 'true') return;
        btn.dataset.calBound = 'true';

        btn.addEventListener('contextmenu', function (e) {
            e.preventDefault();
            var card = btn.closest('.dc');
            if (!card) return;
            var fly = card.querySelector('.dc-cal-fly');
            if (!fly) return;

            document.querySelectorAll('.dc-cal-fly:not([hidden])').forEach(function (openFlyout) {
                openFlyout.hidden = true;
            });

            var itemId = btn.getAttribute('data-item-id');
            var eventIndex = btn.getAttribute('data-event-index');
            fly.querySelectorAll('.dc-cal-fly-item').forEach(function (item) {
                var provider = item.getAttribute('data-provider');
                var href = '/api/items/' + itemId + '/calendar/' + provider + '?eventIndex=' + eventIndex;
                item.setAttribute('href', href);
                if (provider !== 'ics') {
                    item.setAttribute('target', '_blank');
                    item.setAttribute('rel', 'noopener noreferrer');
                } else {
                    item.removeAttribute('target');
                    item.setAttribute('download', 'stackora-' + itemId + '.ics');
                }
            });

            // Position as a fixed flyout so it isn't clipped by card overflow,
            // and anchor it to the icon for a "belongs to this card" feel.
            var btnRect = btn.getBoundingClientRect();
            fly.style.position = 'fixed';
            fly.style.zIndex = '1000';
            fly.style.visibility = 'hidden';
            fly.hidden = false;

            // Align the flyout's right edge to the button's right edge by default.
            var flyRect = fly.getBoundingClientRect();
            var desiredTop = btnRect.bottom + 6;
            var desiredLeft = btnRect.right - flyRect.width;

            var pad = 8;
            var maxLeft = Math.max(pad, window.innerWidth - flyRect.width - pad);
            var maxTop = Math.max(pad, window.innerHeight - flyRect.height - pad);
            var left = Math.min(maxLeft, Math.max(pad, desiredLeft));
            var top = Math.min(maxTop, Math.max(pad, desiredTop));

            fly.style.left = left + 'px';
            fly.style.top = top + 'px';
            fly.style.visibility = '';
        });
    });
}

function bindDashboardCalendarAddAll(root) {
    (root || document).querySelectorAll('.js-dc-cal-add-all').forEach(function (btn) {
        if (btn.dataset.calAllBound === 'true') return;
        btn.dataset.calAllBound = 'true';

        btn.addEventListener('click', function (e) {
            e.preventDefault();

            var itemId = btn.getAttribute('data-item-id');
            var provider = btn.getAttribute('data-provider') || 'ics';
            var isIcs = btn.getAttribute('data-ics') === 'true' || provider === 'ics';
            var count = parseInt(btn.getAttribute('data-count') || '0', 10);
            var url = '/api/items/' + itemId + '/calendar/' + provider + '/all';

            btn.classList.add('is-loading');

            if (isIcs) {
                // Trigger .ics download via a temporary anchor element.
                var a = document.createElement('a');
                a.href = url;
                a.download = 'stackora-' + itemId + '-all.ics';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                btn.classList.remove('is-loading');
                toast.success(count + ' event' + (count !== 1 ? 's' : '') + ' saved — open the downloaded file to import into your calendar.');
                trackEvent('add_to_calendar_all', { provider: provider, count: count });
                return;
            }

            // For connected OAuth providers (googleapi, microsoftgraph): call the endpoint and handle JSON response.
            fetch(url, { method: 'GET', credentials: 'same-origin' })
                .then(function (res) {
                    return res.json().catch(function () { return null; });
                })
                .then(function (data) {
                    if (data && data.created != null) {
                        toast.success('Added ' + data.created + ' of ' + data.total + ' event' + (data.total !== 1 ? 's' : '') + ' to your calendar.');
                    } else if (data && data.error) {
                        toast.error(data.error);
                    } else if (data !== null) {
                        toast.success('Calendar events added.');
                    }
                    trackEvent('add_to_calendar_all', { provider: provider, count: count });
                })
                .catch(function () {
                    toast.error('Could not add events to calendar. Please try again.');
                })
                .finally(function () {
                    btn.classList.remove('is-loading');
                });
        });
    });
}

function bindDashboardInteractiveRegions(root) {
    bindDashboardCopyButtons(root);
    bindDashboardCalendarFlyouts(root);
    bindDashboardCalendarAddAll(root);
    bindDashboardForwardingVerificationConfirmFlow(root);
}

function bindDashboardForwardingVerificationConfirmFlow(root) {
    if (!root) return;

    var dialog = root.querySelector('#dash-verif-dismiss-overlay') || document.getElementById('dash-verif-dismiss-overlay');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var closeButtons = dialog.querySelectorAll('[data-dash-verif-close]');
    var keepBtn = dialog.querySelector('[data-dash-verif-keep]');
    var dismissBtn = dialog.querySelector('[data-dash-verif-dismiss]');
    var providerEl = dialog.querySelector('#dash-verif-dialog-provider');
    var subjectEl = dialog.querySelector('#dash-verif-dialog-subject');
    var metaRow = dialog.querySelector('.dash-verif-dialog__meta');

    var activeId = null;
    var activeProvider = null;
    var activeSubject = null;

    function closeDialog() {
        if (!dialog.open) return;
        dialog.close();
    }

    closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            closeDialog();
        });
    });

    if (keepBtn) {
        keepBtn.addEventListener('click', function () {
            trackEvent('forwarding_verification_keep_after_confirm_click', {});
            closeDialog();
        });
    }

    if (dismissBtn) {
        dismissBtn.addEventListener('click', function () {
            if (!activeId) {
                closeDialog();
                return;
            }

            var token = getCsrfToken(root) || getCsrfToken(document);
            var headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
            };
            if (token) headers['X-CSRF-TOKEN'] = token;

            dismissBtn.disabled = true;
            dismissBtn.classList.add('is-loading');

            fetch('/dashboard/dismiss-verification', {
                method: 'POST',
                credentials: 'same-origin',
                headers: headers,
                body:
                    (token ? '__RequestVerificationToken=' + encodeURIComponent(token) + '&' : '') +
                    'id=' + encodeURIComponent(activeId)
            })
                .then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json().catch(function () { return {}; });
                })
                .then(function () {
                    trackEvent('forwarding_verification_dismiss_after_confirm_click', {
                        provider: activeProvider || 'Unknown'
                    });
                    if (typeof toast !== 'undefined' && toast && typeof toast.success === 'function') {
                        toast.success('Got it — we’ll stop showing that confirmation step.');
                    }
                    closeDialog();
                    if (window.Stackora && typeof window.Stackora.refreshDashboardStatusRegion === 'function') {
                        window.Stackora.refreshDashboardStatusRegion();
                    }
                })
                .catch(function () {
                    if (typeof toast !== 'undefined' && toast && typeof toast.error === 'function') {
                        toast.error('Could not dismiss that message. Please try again.');
                    }
                })
                .finally(function () {
                    dismissBtn.disabled = false;
                    dismissBtn.classList.remove('is-loading');
                });
        });
    }

    dialog.addEventListener('cancel', function () {
        closeDialog();
    });

    root.querySelectorAll('.dash-verif-link-btn[data-verif-id]').forEach(function (link) {
        if (link.dataset.verifConfirmBound === 'true') return;
        link.dataset.verifConfirmBound = 'true';

        link.addEventListener('click', function (e) {
            // Never open this modal unless the user explicitly clicked the confirm link.
            if (!e || e.isTrusted !== true) return;
            if (e.button !== 0) return;
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            if (dialog.open) return;

            activeId = link.getAttribute('data-verif-id');
            activeProvider = link.getAttribute('data-verif-provider');
            activeSubject = link.getAttribute('data-verif-subject');

            if (providerEl) providerEl.textContent = activeProvider ? activeProvider : '';
            if (subjectEl) subjectEl.textContent = activeSubject ? (' — ' + activeSubject) : '';
            if (metaRow) metaRow.hidden = !(activeProvider || activeSubject);

            // Let the provider link open in a new tab, but keep the user anchored here with a clear next step.
            try { dialog.showModal(); } catch (err) { /* no-op */ }

            trackEvent('forwarding_verification_confirm_link_clicked', {
                provider: activeProvider || 'Unknown'
            });
        });
    });
}

function applyDashboardTestEmailSessionLock() {
    if (!window.Stackora || !window.Stackora.dashboardVerificationSentThisPage) return;
    document.querySelectorAll('[data-send-test-email]').forEach(function (btn) {
        btn.dataset.sending = 'false';
        btn.disabled = true;
        btn.title = 'Refresh the page to send another verification message.';
        var label = btn.querySelector('.dash-copy-label');
        if (label) {
            label.textContent = 'Verification sent';
        }
    });
}

function sendDashboardTestEmail(triggerButton) {
    var buttons = Array.from(document.querySelectorAll('[data-send-test-email]'));
    if (buttons.length === 0) return;
    if (window.Stackora && window.Stackora.dashboardVerificationSentThisPage) {
        toast.info('You already sent a verification message this visit. Refresh the page to send another.');
        return;
    }
    if (buttons.some(function (btn) { return btn.dataset.sending === 'true'; })) return;

    var placement = triggerButton ? (triggerButton.getAttribute('data-send-test-email') || 'dashboard_unknown') : 'dashboard_unknown';
    var tokenForm = document.getElementById('dash-test-email-token-form');
    var token = getCsrfToken(tokenForm || document);
    var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };

    if (token) {
        headers['X-CSRF-TOKEN'] = token;
    }

    trackEvent('dashboard_test_email_clicked', { placement: placement });

    var buttonStates = buttons.map(function (btn) {
        var label = btn.querySelector('.dash-copy-label');
        return {
            btn: btn,
            label: label,
            text: label ? label.textContent : ''
        };
    });

    buttonStates.forEach(function (state) {
        state.btn.dataset.sending = 'true';
        state.btn.disabled = true;
        if (state.label) {
            state.label.textContent = 'Sending...';
        }
    });

    var sendSucceeded = false;
    fetch('/dashboard/send-test-email', {
        method: 'POST',
        credentials: 'same-origin',
        headers: headers,
        body: token ? '__RequestVerificationToken=' + encodeURIComponent(token) : ''
    })
        .then(function (res) {
            if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (data) {
                    if (data && data.error === 'onboarding_required' && data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                        throw new Error('Redirecting to onboarding...');
                    }

                    throw new Error(data.error || ('HTTP ' + res.status));
                });
            }

            return res.json();
        })
        .then(function (data) {
            if (data.sent) {
                sendSucceeded = true;
                toast.success('Verification message sent. We\'ll confirm it in your dashboard shortly.');
                if (window.Stackora && typeof window.Stackora.refreshDashboardStatusRegion === 'function') {
                    window.Stackora.refreshDashboardStatusRegion();
                }
                if (window.Stackora && window.Stackora.signalr && !window.Stackora.signalr.isConnected()) {
                    toast.info('Live updates are reconnecting. If confirmation takes a while, refresh the page.', { duration: 4000 });
                }
            } else {
                toast.error(data.error || 'Something went wrong.');
            }
        })
        .catch(function (err) {
            var message = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
            toast.error(message);
        })
        .finally(function () {
            if (sendSucceeded) {
                window.Stackora = window.Stackora || {};
                window.Stackora.dashboardVerificationSentThisPage = true;
                applyDashboardTestEmailSessionLock();
                return;
            }
            buttonStates.forEach(function (state) {
                state.btn.dataset.sending = 'false';
                state.btn.disabled = false;
                if (state.label) {
                    state.label.textContent = state.text;
                }
            });
        });
}

function initDashboardUi() {
    bindDashboardInteractiveRegions(document);
    bindMessageLinkCopyButtons(document);

    // Upgrade usage CTA tracking
    document.addEventListener('click', function (e) {
        var testButton = e.target.closest('[data-send-test-email]');
        if (testButton) {
            e.preventDefault();
            sendDashboardTestEmail(testButton);
            return;
        }

        var primary = e.target.closest('[data-upgrade-cta-primary]');
        if (primary) {
            var shell = primary.closest('[data-upgrade-usage-state]');
            var state = shell ? shell.getAttribute('data-upgrade-usage-state') || 'unknown' : 'unknown';
            trackEvent('upgrade_banner_click', { banner_state: state, cta: 'primary' });
            return;
        }

        var secondary = e.target.closest('[data-upgrade-cta-secondary]');
        if (secondary) {
            var shell2 = secondary.closest('[data-upgrade-usage-state]');
            var state2 = shell2 ? shell2.getAttribute('data-upgrade-usage-state') || 'unknown' : 'unknown';
            trackEvent('compare_plans_click', { banner_state: state2, cta: 'secondary' });
        }
    });

    // GA: digest details expanded (native <details> toggle)
    document.addEventListener('toggle', function (e) {
        if (e.target.classList && e.target.classList.contains('dc-details') && e.target.open) {
            trackEvent('view_digest_details', {});
            var card = e.target.closest('.dc');
            recordIntelligenceSignal('DetailsViewed', card);
        }
    });

    // Add to calendar: track when user clicks a provider link (Google, Apple, ICS, etc.)
    document.addEventListener('click', function (e) {
        var directLink = e.target.closest('.js-dc-cal-add');
        if (directLink) {
            var href = directLink.getAttribute('href') || '';
            var match = href.match(/\/calendar\/([^/?]+)/);
            trackEvent('add_to_calendar', { provider: match ? match[1] : 'default' });
            var directCard = directLink.closest('.dc');
            recordIntelligenceSignal('CalendarAdded', directCard);
            return;
        }

        var link = e.target.closest('.dc-cal-fly-item');
        if (link && link.getAttribute('data-provider')) {
            trackEvent('add_to_calendar', { provider: link.getAttribute('data-provider') });
            var card = link.closest('.dc');
            recordIntelligenceSignal('CalendarAdded', card);
        }
    });

    // Track outbound link clicks in digest card details (LinkClicked signal)
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var card = link.closest('.dc');
        if (!card) return;
        var href = link.getAttribute('href') || '';
        // Only track external links (not internal navigation or calendar links)
        if (href.indexOf('http') === 0 && !link.closest('.dc-cal-fly') && !link.classList.contains('js-dc-cal-add')) {
            recordIntelligenceSignal('LinkClicked', card);
        }
    });

    // Close flyouts on click outside or Escape.
    document.addEventListener('click', function (e) {
        document.querySelectorAll('.dc-cal-fly:not([hidden])').forEach(function (fly) {
            if (!fly.contains(e.target) && !e.target.closest('.js-dc-cal-add')) {
                fly.hidden = true;
            }
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.dc-cal-fly:not([hidden])').forEach(function (fly) {
            fly.hidden = true;
        });
    });

    // Feed reveal staging for smoother first paint.
    var revealIndex = 0;
    document.querySelectorAll('.dash-feed .dc').forEach(function (card) {
        card.style.setProperty('--dc-i', String(revealIndex));
        revealIndex += 1;
    });

    // ── Animated hero counter (count up from 0) ──
    document.querySelectorAll('.dash-hero-counter-num').forEach(function (el) {
        var target = parseInt(el.textContent, 10);
        if (isNaN(target) || target <= 0) return;
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) return;
        el.textContent = '0';
        var duration = Math.min(800, Math.max(300, target * 60));
        var start = performance.now();
        function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var ease = 1 - Math.pow(1 - progress, 3);
            el.textContent = String(Math.round(target * ease));
            if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    });

    // Also animate status values (Attention, Updates, Muted counts)
    document.querySelectorAll('.dash-hero-status-value').forEach(function (el) {
        var target = parseInt(el.textContent, 10);
        if (isNaN(target) || target <= 0) return;
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) return;
        el.textContent = '0';
        var duration = Math.min(600, Math.max(200, target * 50));
        var start = performance.now();
        function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var ease = 1 - Math.pow(1 - progress, 3);
            el.textContent = String(Math.round(target * ease));
            if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    });

    // ── Usage meter fill animation ──
    document.querySelectorAll('.dash-usage-fill').forEach(function (el) {
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) return;
        var targetWidth = el.style.width;
        el.style.width = '0%';
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                el.style.width = targetWidth;
            });
        });
    });

    // ── Smooth section collapse (CSS-only handles animation, JS handles toggle for grid trick) ──
    document.querySelectorAll('details.dash-section-collapse').forEach(function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('.dash-section-content');
        if (!summary || !content) return;

        summary.addEventListener('click', function (e) {
            e.preventDefault();
            if (details.open) {
                content.style.gridTemplateRows = '0fr';
                content.addEventListener('transitionend', function handler() {
                    details.open = false;
                    content.removeEventListener('transitionend', handler);
                }, { once: true });
            } else {
                details.open = true;
                requestAnimationFrame(function () {
                    content.style.gridTemplateRows = '1fr';
                });
            }
        });
    });

    // ── Overflow menu (three-dot) ──
    var activeOverflowMenu = null;
    var overflowPlacementRafId = null;

    function applyOverflowMenuPlacement(btn, menu) {
        menu.classList.remove('dc-overflow-menu--open-up');
        menu.style.maxHeight = '';
        menu.style.overflowY = '';

        var margin = 8;
        var btnRect = btn.getBoundingClientRect();
        var menuRect = menu.getBoundingClientRect();
        var menuH = menuRect.height;
        if (menuH < 4) return;

        var spaceBelow = window.innerHeight - btnRect.bottom - margin;
        var spaceAbove = btnRect.top - margin;

        if (menuH <= spaceBelow) {
            return;
        }
        if (menuH <= spaceAbove) {
            menu.classList.add('dc-overflow-menu--open-up');
            return;
        }
        if (spaceAbove > spaceBelow) {
            menu.classList.add('dc-overflow-menu--open-up');
            menu.style.maxHeight = Math.max(spaceAbove - 4, 120) + 'px';
            menu.style.overflowY = 'auto';
        } else {
            menu.style.maxHeight = Math.max(spaceBelow - 4, 120) + 'px';
            menu.style.overflowY = 'auto';
        }
    }

    function scheduleOverflowMenuPlacement() {
        if (!activeOverflowMenu) return;
        if (overflowPlacementRafId !== null) return;
        overflowPlacementRafId = requestAnimationFrame(function () {
            overflowPlacementRafId = null;
            if (!activeOverflowMenu) return;
            var wrap = activeOverflowMenu.closest('.dc-overflow-wrap');
            var b = wrap && wrap.querySelector('.js-dc-overflow');
            if (b) applyOverflowMenuPlacement(b, activeOverflowMenu);
        });
    }

    function closeOverflowMenu() {
        if (!activeOverflowMenu) return;
        var menu = activeOverflowMenu;
        if (overflowPlacementRafId !== null) {
            cancelAnimationFrame(overflowPlacementRafId);
            overflowPlacementRafId = null;
        }
        window.removeEventListener('resize', scheduleOverflowMenuPlacement);
        document.removeEventListener('scroll', scheduleOverflowMenuPlacement, true);
        menu.classList.remove('dc-overflow-menu--open-up');
        menu.style.maxHeight = '';
        menu.style.overflowY = '';
        var btn = menu.previousElementSibling || menu.closest('.dc-overflow-wrap').querySelector('.js-dc-overflow');
        menu.setAttribute('aria-hidden', 'true');
        menu.setAttribute('hidden', '');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        activeOverflowMenu = null;
    }

    function openOverflowMenu(btn) {
        var wrap = btn.closest('.dc-overflow-wrap');
        if (!wrap) return;
        var menu = wrap.querySelector('.dc-overflow-menu');
        if (!menu) return;

        // Close any other open menu first
        if (activeOverflowMenu && activeOverflowMenu !== menu) {
            closeOverflowMenu();
        }

        var isOpen = menu.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
            closeOverflowMenu();
            return;
        }

        menu.removeAttribute('hidden');
        // Force reflow for transition
        void menu.offsetHeight;
        menu.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        activeOverflowMenu = menu;

        window.addEventListener('resize', scheduleOverflowMenuPlacement);
        document.addEventListener('scroll', scheduleOverflowMenuPlacement, true);

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                applyOverflowMenuPlacement(btn, menu);
                var firstItem = menu.querySelector('.dc-overflow-item');
                if (firstItem) firstItem.focus();
            });
        });
    }

    // Toggle on click
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-overflow');
        if (btn) {
            e.stopPropagation();
            e.preventDefault();
            openOverflowMenu(btn);
            return;
        }

        // Close on outside click
        if (activeOverflowMenu && !e.target.closest('.dc-overflow-menu')) {
            closeOverflowMenu();
        }
    });

    // Keyboard navigation inside menu
    document.addEventListener('keydown', function (e) {
        if (!activeOverflowMenu) return;

        if (e.key === 'Escape') {
            e.preventDefault();
            var wrap = activeOverflowMenu.closest('.dc-overflow-wrap');
            closeOverflowMenu();
            var triggerBtn = wrap && wrap.querySelector('.js-dc-overflow');
            if (triggerBtn) triggerBtn.focus();
            return;
        }

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            var items = Array.from(activeOverflowMenu.querySelectorAll('.dc-overflow-item'));
            if (items.length === 0) return;
            var idx = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') idx = idx < items.length - 1 ? idx + 1 : 0;
            else idx = idx > 0 ? idx - 1 : items.length - 1;
            items[idx].focus();
        }

        if (e.key === 'Tab') {
            closeOverflowMenu();
        }
    });

    // ── Subscription digest mode change (from overflow menu) ──
    document.addEventListener('click', function (e) {
        var modeBtn = e.target.closest('.js-dc-digest-mode');
        if (!modeBtn) return;
        e.preventDefault();
        e.stopPropagation();

        var card = modeBtn.closest('.dc');
        if (!card) return;
        var senderEmail = card.getAttribute('data-sender-email');
        if (!senderEmail) return;
        var mode = modeBtn.getAttribute('data-mode');
        if (!mode) return;

        // Update UI optimistically
        var menu = modeBtn.closest('.dc-overflow-menu');
        if (menu) {
            menu.querySelectorAll('.js-dc-digest-mode').forEach(function (b) {
                b.setAttribute('aria-checked', b === modeBtn ? 'true' : 'false');
            });
        }
        closeOverflowMenu();

        fetch('/settings/subscription-preference', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ senderEmail: senderEmail, digestMode: mode })
        })
        .then(function (res) {
            if (!res.ok) throw new Error();
            return res.json();
        })
        .then(function (data) {
            if (data.success) {
                trackEvent('subscription_preference_changed', { mode: mode });
                // Layout (full card vs headline list vs skipped) is server-rendered; reload so the digest matches the new preference.
                window.location.reload();
            } else {
                toast.error(data.message || 'Could not update preference.');
            }
        })
        .catch(function () {
            toast.error('Could not update preference. Please try again.');
            // Revert UI on failure
            if (menu) {
                menu.querySelectorAll('.js-dc-digest-mode').forEach(function (b) {
                    // We don't know the old value, so just leave as-is
                });
            }
        });
    });

    // ── Retry failed emails ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('#dash-retry-failed-btn');
        if (!btn) return;
        e.preventDefault();

        btn.disabled = true;
        btn.textContent = 'Retrying…';

        fetch('/dashboard/retry-all-failed', {
            method: 'POST',
            headers: csrfHeaders()
        })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
        .then(function (data) {
            if (data.queued > 0) {
                toast.success('Queued ' + data.queued + ' ' + (data.queued === 1 ? 'email' : 'emails') + ' for retry.');
                // Reload the feed chrome to reflect updated pipeline status
                var feedTarget = document.getElementById('dash-feed-inline-chrome');
                if (feedTarget) {
                    fetch('/dashboard/feed-chrome' + (location.search || ''))
                        .then(function (r) { return r.ok ? r.text() : null; })
                        .then(function (html) { if (html) feedTarget.outerHTML = html; })
                        .catch(function () {});
                }
            } else {
                toast.info('No emails eligible for retry.');
                btn.disabled = false;
                btn.textContent = 'Retry';
            }
        })
        .catch(function () {
            toast.error('Retry failed. Please try again.');
            btn.disabled = false;
            btn.textContent = 'Retry';
        });
    });

    // ── Card archive (delegated so it works for async-loaded cards too) ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-archive');
        if (!btn) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;
        var itemId = card.getAttribute('data-item-id');
        if (!itemId) return;

        if (btn.closest('.dc-overflow-menu')) {
            closeOverflowMenu();
        }

        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch('/dashboard/archive', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ id: itemId })
        })
        .then(function (res) {
            if (!res.ok) throw new Error('Set aside failed');
            return res.json();
        })
        .then(function () {
            var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            function removeAndUpdate() {
                // Capture section and counts before removing card (card is detached after remove)
                var section = card.closest('.dash-section');
                var countEl = section ? section.querySelector('.dash-section-count') : null;
                var isAttentionSection = section && section.querySelector('.dash-section-dot--attn');
                var isUpdatesSection = section && section.querySelector('.dash-section-dot--info');
                var isMutedSection = section && section.querySelector('.dash-section-dot--muted');

                var feedItem = card.closest('.dash-feed-item');
                var nextFeedItem = feedItem && feedItem.nextElementSibling;
                var sectionSummary = section && section.querySelector('summary');

                if (feedItem) feedItem.remove(); else card.style.display = 'none';

                if (countEl) {
                    var current = parseInt(countEl.textContent, 10);
                    if (!isNaN(current) && current > 0) {
                        countEl.textContent = String(current - 1);
                    }
                }

                // If section is now empty of feed items, fade it out
                if (section) {
                    var remaining = section.querySelectorAll('.dash-feed-item');
                    if (remaining.length === 0) {
                        section.style.transition = 'opacity 0.25s ease, max-height 0.3s ease';
                        section.style.opacity = '0';
                        section.addEventListener('transitionend', function () { section.remove(); }, { once: true });
                    }
                }

                // Update the brief counter (items ready + Attention/Updates). Unscoped: the counter
                // lives in the command-center brief card (.dash-brief), not inside .dash-hero.
                var heroTotal = document.querySelector('.dash-hero-counter-num');
                if (heroTotal) {
                    var total = parseInt(heroTotal.textContent, 10);
                    if (!isNaN(total) && total > 0) heroTotal.textContent = String(total - 1);
                }
                var statusValues = document.querySelectorAll('.dash-hero-status-value');
                if (isAttentionSection && statusValues.length > 0) {
                    var attn = parseInt(statusValues[0].textContent, 10);
                    if (!isNaN(attn) && attn > 0) statusValues[0].textContent = String(attn - 1);
                } else if (isUpdatesSection && statusValues.length > 1) {
                    var upd = parseInt(statusValues[1].textContent, 10);
                    if (!isNaN(upd) && upd > 0) statusValues[1].textContent = String(upd - 1);
                } else if (isMutedSection && statusValues.length > 2) {
                    var mut = parseInt(statusValues[2].textContent, 10);
                    if (!isNaN(mut) && mut > 0) statusValues[2].textContent = String(mut - 1);
                }

                // Move focus so keyboard users don't lose place
                var focusTarget = null;
                if (nextFeedItem) {
                    focusTarget = nextFeedItem.querySelector('.dc-quick-actions button, .dc-feedback button, .dc-details-toggle, .dc a[href]') || nextFeedItem.querySelector('.dc');
                }
                if (!focusTarget && sectionSummary) focusTarget = sectionSummary;
                if (focusTarget && typeof focusTarget.focus === 'function') {
                    if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
                    focusTarget.focus({ preventScroll: true });
                }
            }

            trackEvent('item_archived', {});
            if (prefersReducedMotion) {
                removeAndUpdate();
            } else {
                card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                card.style.opacity = '0';
                card.style.transform = 'translateX(40px)';
                card.addEventListener('transitionend', removeAndUpdate, { once: true });
            }

            toast.success('Item set aside', {
                undo: function () {
                    fetch('/dashboard/unarchive', {
                        method: 'POST',
                        headers: csrfHeaders(),
                        body: JSON.stringify({ id: itemId })
                    }).then(function (res) {
                        if (!res.ok) throw new Error();
                        // Reload the feed in-place instead of full page reload
                        var target = document.getElementById('dash-feed-target');
                        if (!target) { location.reload(); return; }
                        var view = getDashboardActiveView();
                        var q = getDashboardSearchQuery();
                        target.setAttribute('aria-busy', 'true');
                        beginDashboardFeedLoading(target);
                        return fetch(buildDashboardFeedUrl(view, q), { credentials: 'same-origin' })
                            .then(function (r) { return r.text(); })
                            .then(function (html) { replaceDashboardFeedFromHtml(target, html); })
                            .catch(function () {
                                endDashboardFeedLoading(target);
                                toast.error("Couldn't undo. Please refresh the page.");
                            });
                    }).catch(function () {
                        toast.error("Couldn't undo. Please refresh the page.");
                    });
                }
            });
        })
        .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            toast.error("Couldn't set this aside. Please try again.");
        });
    });

    // ── Card delete (delegated) ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-delete-email');
        if (!btn) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;
        var itemId = card.getAttribute('data-item-id');
        if (!itemId) return;

        var confirmed = window.confirm('Delete this email?\n\nThis permanently removes the email, its saved summary, and any linked actions. This can\'t be undone.');
        if (!confirmed) return;

        if (btn.closest('.dc-overflow-menu')) {
            closeOverflowMenu();
        }

        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch('/dashboard/delete-email', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ id: itemId })
        })
        .then(function (res) {
            if (res.status === 404) throw new Error('not_found');
            if (!res.ok) throw new Error('delete_failed');
            return res.json();
        })
        .then(function (data) {
            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            function refreshFeed() {
                if (window.Stackora && typeof window.Stackora.refreshDashboardFeed === 'function') {
                    window.Stackora.refreshDashboardFeed();
                    return;
                }

                location.reload();
            }

            if (reduced) {
                refreshFeed();
            } else {
                card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
                card.style.opacity = '0';
                card.style.transform = 'translateX(40px)';
                var refreshFallback = setTimeout(refreshFeed, 500);
                card.addEventListener('transitionend', function () {
                    clearTimeout(refreshFallback);
                    refreshFeed();
                }, { once: true });
            }

            toast.success(data && data.pendingCleanup
                ? 'Email removed. We\'re finishing cleanup in the background.'
                : 'Email deleted');
        })
        .catch(function (err) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            if (err && err.message === 'not_found') {
                toast.info('That email was already removed.');
                if (window.Stackora && typeof window.Stackora.refreshDashboardFeed === 'function') {
                    window.Stackora.refreshDashboardFeed();
                }
                return;
            }

            toast.error("Couldn't delete this email. Please try again.");
        });
    });

    // ── Digest item feedback (delegated) ──
    var UNDO_WINDOW_MS = 5000;

    function submitFeedback(card, signal, reason, comment) {
        var itemId = card.getAttribute('data-item-id');
        if (!itemId) return Promise.reject();

        var body = { id: itemId, signal: signal };
        if (reason) body.reason = reason;
        if (comment) body.comment = comment;

        return fetch('/dashboard/feedback', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify(body)
        }).then(function (res) {
            if (!res.ok) throw new Error('Feedback failed');
            return res.json();
        });
    }

    function announceFeedback(card, text) {
        var sr = card.querySelector('.dc-feedback-sr');
        if (sr) sr.textContent = text;
    }

    function showConfirmAnimation(btn) {
        btn.classList.add('dc-fb-btn--confirming');
        setTimeout(function () { btn.classList.remove('dc-fb-btn--confirming'); }, 600);
    }

    function showFeedbackThanks(card, signal) {
        var strip = card.querySelector('.dc-feedback');
        if (!strip) return;
        var thanks = strip.querySelector('.dc-feedback-thanks');
        if (thanks) {
            thanks.hidden = false;
            clearTimeout(thanks._hideTimer);
            thanks._hideTimer = setTimeout(function () {
                thanks.hidden = true;
                // Hide the undo button after the window expires
            }, UNDO_WINDOW_MS);
        }
        strip.classList.add('dc-feedback--answered');
        announceFeedback(card, signal === 'helpful' ? 'Marked as helpful' : 'Marked as could be better');
    }

    function hideFeedbackThanks(card) {
        var strip = card.querySelector('.dc-feedback');
        if (!strip) return;
        var thanks = strip.querySelector('.dc-feedback-thanks');
        if (thanks) {
            clearTimeout(thanks._hideTimer);
            thanks.hidden = true;
        }
    }

    function setFeedbackVisual(card, signal) {
        var upBtn = card.querySelector('.js-dc-fb-up');
        var downBtn = card.querySelector('.js-dc-fb-down');
        if (upBtn) {
            upBtn.classList.toggle('dc-fb-btn--active', signal === 'helpful');
            var upSvg = upBtn.querySelector('.dc-fb-icon');
            if (upSvg) upSvg.setAttribute('fill', signal === 'helpful' ? 'currentColor' : 'none');
        }
        if (downBtn) {
            downBtn.classList.toggle('dc-fb-btn--active', signal === 'unhelpful');
            var downSvg = downBtn.querySelector('.dc-fb-icon');
            if (downSvg) downSvg.setAttribute('fill', signal === 'unhelpful' ? 'currentColor' : 'none');
        }
        var strip = card.querySelector('.dc-feedback');
        if (strip) {
            strip.setAttribute('data-signal', signal);
            strip.classList.toggle('dc-feedback--answered', !!signal);
        }
    }

    function closeReasonFlyout(card) {
        var reasons = card.querySelector('.dc-fb-reasons');
        if (reasons) {
            reasons.hidden = true;
            reasons.querySelectorAll('.dc-fb-reason-chip').forEach(function (c) {
                c.classList.remove('dc-fb-reason-chip--selected');
            });
            var commentRow = reasons.querySelector('.dc-fb-comment-row');
            if (commentRow) commentRow.hidden = true;
            var textarea = reasons.querySelector('.dc-fb-comment');
            if (textarea) textarea.value = '';
        }
    }

    function getCurrentSignal(card) {
        var strip = card.querySelector('.dc-feedback');
        return strip ? strip.getAttribute('data-signal') || '' : '';
    }

    function setFeedbackBusy(card, busy) {
        var up = card.querySelector('.js-dc-fb-up');
        var down = card.querySelector('.js-dc-fb-down');
        if (up) up.disabled = busy;
        if (down) down.disabled = busy;
    }

    function resetFeedbackToNeutral(card) {
        closeReasonFlyout(card);
        hideFeedbackThanks(card);
        setFeedbackVisual(card, '');
        announceFeedback(card, 'Feedback removed');
    }

    // Thumbs up
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-fb-up');
        if (!btn || btn.disabled) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;

        // Already helpful — nothing to do
        if (getCurrentSignal(card) === 'helpful') return;

        closeReasonFlyout(card);
        setFeedbackVisual(card, 'helpful');
        showConfirmAnimation(btn);
        setFeedbackBusy(card, true);

        submitFeedback(card, 'helpful')
            .then(function () {
                setFeedbackBusy(card, false);
                showFeedbackThanks(card, 'helpful');
                trackEvent('digest_feedback', { signal: 'helpful' });
            })
            .catch(function () {
                setFeedbackBusy(card, false);
                setFeedbackVisual(card, '');
                announceFeedback(card, 'Feedback failed, please try again');
                toast.error("Feedback couldn't be saved. Please try again.");
            });
    });

    // Thumbs down — open reason flyout (or close if already down)
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-fb-down');
        if (!btn || btn.disabled) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;

        hideFeedbackThanks(card);

        var wasDown = getCurrentSignal(card) === 'unhelpful';
        var reasons = card.querySelector('.dc-fb-reasons');

        // If already unhelpful, toggle the flyout
        if (wasDown && reasons) {
            if (reasons.hidden) {
                reasons.hidden = false;
            } else {
                closeReasonFlyout(card);
            }
            return;
        }

        setFeedbackVisual(card, 'unhelpful');

        if (reasons) {
            reasons.hidden = false;
            reasons.querySelectorAll('.dc-fb-reason-chip').forEach(function (c) {
                c.classList.remove('dc-fb-reason-chip--selected');
            });
            var commentRow = reasons.querySelector('.dc-fb-comment-row');
            if (commentRow) commentRow.hidden = true;
            var textarea = reasons.querySelector('.dc-fb-comment');
            if (textarea) textarea.value = '';
        }
    });

    // Reason chip selection
    document.addEventListener('click', function (e) {
        var chip = e.target.closest('.js-dc-fb-reason');
        if (!chip) return;
        e.stopPropagation();

        var card = chip.closest('.dc');
        if (!card) return;

        var reasons = card.querySelector('.dc-fb-reasons');
        if (!reasons) return;

        // Update selection
        reasons.querySelectorAll('.dc-fb-reason-chip').forEach(function (c) {
            c.classList.remove('dc-fb-reason-chip--selected');
        });
        chip.classList.add('dc-fb-reason-chip--selected');

        var isOther = chip.getAttribute('data-reason') === 'Other';
        var commentRow = reasons.querySelector('.dc-fb-comment-row');

        if (isOther) {
            if (commentRow) commentRow.hidden = false;
            var textarea = reasons.querySelector('.dc-fb-comment');
            if (textarea) setTimeout(function () { textarea.focus(); }, 100);
        } else {
            // Hide comment row and auto-submit for non-Other reasons
            if (commentRow) commentRow.hidden = true;
            var reason = chip.getAttribute('data-reason');

            setFeedbackBusy(card, true);
            submitFeedback(card, 'unhelpful', reason)
                .then(function () {
                    setFeedbackBusy(card, false);
                    closeReasonFlyout(card);
                    showFeedbackThanks(card, 'unhelpful');
                    trackEvent('digest_feedback', { signal: 'unhelpful', reason: reason });
                })
                .catch(function () {
                    setFeedbackBusy(card, false);
                    announceFeedback(card, 'Feedback failed, please try again');
                    toast.error("Feedback couldn't be saved. Please try again.");
                });
        }
    });

    // Submit "Other" feedback with comment
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-fb-submit');
        if (!btn || btn.disabled) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;

        var reasons = card.querySelector('.dc-fb-reasons');
        if (!reasons) return;

        var textarea = reasons.querySelector('.dc-fb-comment');
        var comment = textarea ? textarea.value.trim() : null;

        btn.disabled = true;
        setFeedbackBusy(card, true);

        submitFeedback(card, 'unhelpful', 'Other', comment || null)
            .then(function () {
                btn.disabled = false;
                setFeedbackBusy(card, false);
                closeReasonFlyout(card);
                showFeedbackThanks(card, 'unhelpful');
                trackEvent('digest_feedback', { signal: 'unhelpful', reason: 'Other' });
            })
            .catch(function () {
                btn.disabled = false;
                setFeedbackBusy(card, false);
                announceFeedback(card, 'Feedback failed, please try again');
                toast.error("Feedback couldn't be saved. Please try again.");
            });
    });

    // Undo feedback
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-fb-undo');
        if (!btn) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;

        // Optimistically reset UI, then overwrite server state to "helpful"
        // then immediately back. We use "helpful" as a no-op overwrite since
        // there's no "delete" endpoint — but the visual state resets to neutral.
        // A proper "None" signal would be better; for now we just reset visually.
        resetFeedbackToNeutral(card);
    });

    // Close reason flyout on click outside or Escape
    document.addEventListener('click', function (e) {
        if (e.target.closest('.dc-fb-reasons') || e.target.closest('.js-dc-fb-down')) return;
        document.querySelectorAll('.dc-fb-reasons:not([hidden])').forEach(function (fly) {
            var card = fly.closest('.dc');
            if (card) {
                // Only reset visual if no chip was selected yet (user abandoned)
                var hasSelected = fly.querySelector('.dc-fb-reason-chip--selected');
                closeReasonFlyout(card);
                if (!hasSelected) {
                    setFeedbackVisual(card, '');
                }
            }
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.dc-fb-reasons:not([hidden])').forEach(function (fly) {
            var card = fly.closest('.dc');
            if (card) {
                var hasSelected = fly.querySelector('.dc-fb-reason-chip--selected');
                closeReasonFlyout(card);
                if (!hasSelected) {
                    setFeedbackVisual(card, '');
                }
            }
        });
    });

    // ── Keyboard navigation (j/k/o/c) ──
    var kbCards = [];
    var kbIndex = -1;

    function refreshKbCards() {
        kbCards = Array.from(document.querySelectorAll('.dc'));
    }

    function highlightCard(index) {
        kbCards.forEach(function (c, i) {
            c.classList.toggle('dc--kb-focus', i === index);
        });
        if (kbCards[index]) {
            kbCards[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }

    document.addEventListener('keydown', function (e) {
        // Don't intercept when typing in inputs
        var tag = (e.target.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;
        // Don't intercept when modifiers are held
        if (e.ctrlKey || e.metaKey || e.altKey) return;

        if (e.key === 'j' || e.key === 'k') {
            e.preventDefault();
            refreshKbCards();
            if (kbCards.length === 0) return;
            if (e.key === 'j') kbIndex = Math.min(kbIndex + 1, kbCards.length - 1);
            else kbIndex = Math.max(kbIndex - 1, 0);
            highlightCard(kbIndex);
        }

        if (e.key === 'o' && kbIndex >= 0 && kbIndex < kbCards.length) {
            e.preventDefault();
            var details = kbCards[kbIndex].querySelector('.dc-details');
            if (details) details.open = !details.open;
        }

        if (e.key === 'c' && kbIndex >= 0 && kbIndex < kbCards.length) {
            e.preventDefault();
            var calBtn = kbCards[kbIndex].querySelector('.js-dc-cal-add');
            if (calBtn) calBtn.click();
        }

        // N: Focus action items quick-add input
        if (e.key === 'n') {
            var addInput = document.getElementById('ai-add-input');
            if (addInput) {
                e.preventDefault();
                addInput.focus();
                var compose = addInput.closest('.ai-compose');
                if (compose) compose.classList.add('is-expanded');
                return;
            }
        }

        // Escape clears keyboard focus
        if (e.key === 'Escape' && kbIndex >= 0) {
            kbCards.forEach(function (c) { c.classList.remove('dc--kb-focus'); });
            kbIndex = -1;
        }
    });

    // ── Verification dismiss / reprocess (AJAX with toast + undo) ──
    document.addEventListener('submit', function (e) {
        var form = e.target.closest('.dash-verif-dismiss');
        if (!form) return;
        e.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;

        var formData = new FormData(form);
        var id = formData.get('id');
        var action = form.getAttribute('action');
        var isDismiss = action && action.indexOf('dismiss') !== -1;

        fetch(action, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
        })
        .then(function (res) {
            if (!res.ok) throw new Error();

            // Animate the item out
            var item = form.closest('.dash-verif-item');
            if (item) {
                item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                item.style.opacity = '0';
                item.style.transform = 'translateX(40px)';
                item.addEventListener('transitionend', function () {
                    item.remove();
                    // Remove entire banner if no items left
                    var banner = document.querySelector('.dash-verif-banner');
                    if (banner && !banner.querySelector('.dash-verif-item')) {
                        banner.style.transition = 'opacity 0.25s ease';
                        banner.style.opacity = '0';
                        banner.addEventListener('transitionend', function () { banner.remove(); }, { once: true });
                    }
                }, { once: true });
            }

            if (isDismiss) {
                toast.success('Verification dismissed', {
                    undo: function () {
                        var undoData = new FormData();
                        undoData.append('id', id);
                        var token = formData.get('__RequestVerificationToken');
                        if (token) undoData.append('__RequestVerificationToken', token);
                        fetch('/dashboard/restore-verification', {
                            method: 'POST',
                            headers: { 'Accept': 'application/json' },
                            body: undoData
                        }).then(function (res) {
                            if (!res.ok) throw new Error();
                            location.reload();
                        }).catch(function () {
                            toast.error("Couldn't undo. Please refresh the page.");
                        });
                    }
                });
            } else {
                toast.success('Email queued for reprocessing');
            }
        })
        .catch(function () {
            if (btn) btn.disabled = false;
            toast.error(isDismiss ? "Couldn't dismiss verification. Please try again." : "Couldn't reprocess. Please try again.");
        });
    });

    // ── View tabs (Digest / Archived toggle) ──
    document.addEventListener('click', function (e) {
        var tab = e.target.closest('.dash-view-tab');
        if (!tab || tab.classList.contains('dash-view-tab--active')) return;
        // Locked tabs are plain links to the upgrade page — let them navigate.
        if (tab.classList.contains('dash-view-tab--locked')) return;

        var view = tab.getAttribute('data-view');
        setDashboardActiveView(view || 'digest');
        trackEvent('view_switch', { view: view || 'digest' });

        var target = document.getElementById('dash-feed-target');
        if (!target) return;

        syncDashboardSearchVisibility(view || 'digest');
        syncDashboardSearchScope(view || 'digest');
        target.setAttribute('aria-busy', 'true');
        beginDashboardFeedLoading(target);

        // Show loader bar during tab switch
        var loaderBar = document.querySelector('.dash-loader-bar');
        if (loaderBar) loaderBar.classList.add('dash-loader-bar--visible');

        var q = getDashboardSearchQuery();
        syncDashboardSearchUi(q, {
            isLoading: true,
            loadingMessage: getDashboardLoadingMessage({ reason: 'view', view: view || 'digest', query: q, bucket: 'all' })
        });
        var nextUrl = buildDashboardPageUrl(view || 'digest', q, 'all');
        if (window.location.pathname + window.location.search !== nextUrl) {
            window.history.replaceState({}, '', nextUrl);
        }

        fetch(buildDashboardFeedUrl(view || 'digest', q, 'all'), { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.text();
            })
            .then(function (html) {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                replaceDashboardFeedFromHtml(target, html);
            })
            .catch(function () {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                endDashboardFeedLoading(target);
                syncDashboardSearchUi(q, { isLoading: false });
                toast.error("Couldn't load items. Please try again.");
            });
    });

    document.addEventListener('click', function (e) {
        var filterButton = e.target.closest('[data-dash-bucket-filter]');
        if (!filterButton || !dashboardSupportsDigestBucketFilters()) return;

        e.preventDefault();

        var target = document.getElementById('dash-feed-target');
        if (!target) return;

        var bucket = normalizeDashboardBucketFilter(filterButton.getAttribute('data-dash-bucket-filter') || 'all');
        var query = getDashboardSearchQuery();
        var loaderBar = document.querySelector('.dash-loader-bar');

        setDashboardActiveView('digest');
        syncDashboardSearchVisibility('digest');
        syncDashboardSearchScope('digest');
        target.setAttribute('aria-busy', 'true');
        beginDashboardFeedLoading(target);
        if (loaderBar) loaderBar.classList.add('dash-loader-bar--visible');
        syncDashboardSearchUi(query, {
            isLoading: true,
            loadingMessage: getDashboardLoadingMessage({ reason: 'bucket', view: 'digest', query: query, bucket: bucket })
        });

        var nextUrl = buildDashboardPageUrl('digest', query, bucket);
        if (window.location.pathname + window.location.search !== nextUrl) {
            window.history.replaceState({}, '', nextUrl);
        }

        fetch(buildDashboardFeedUrl('digest', query, bucket), { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.text();
            })
            .then(function (html) {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                replaceDashboardFeedFromHtml(target, html);
            })
            .catch(function () {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                endDashboardFeedLoading(target);
                syncDashboardSearchUi(query, { isLoading: false });
                toast.error("Couldn't update your " + getDashboardBriefNoun() + " view. Please try again.");
            });
    });

    document.addEventListener('click', function (e) {
        var viewJump = e.target.closest('[data-dash-view-jump]');
        if (!viewJump) return;

        e.preventDefault();

        var view = viewJump.getAttribute('data-dash-view-jump') || 'digest';
        var tab = document.querySelector('.dash-view-tab[data-view="' + view + '"]');
        if (tab) {
            tab.click();
        }
    });

    document.addEventListener('click', function (e) {
        var mobileToggle = e.target.closest('.js-dc-mobile-toggle');
        if (!mobileToggle) return;

        e.preventDefault();

        var card = mobileToggle.closest('.dc');
        if (!card) return;

        var expanded = !card.classList.contains('dc--expanded');
        card.dataset.mobileExpanded = expanded ? 'true' : 'false';
        setFocusedCardExpanded(card, expanded);
        if (card.classList.contains('dc--compact')) tryDigestExpandHaptic();
    });

    // ── Restore archived item (delegated) ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-restore');
        if (!btn) return;
        e.stopPropagation();

        var card = btn.closest('.dc');
        if (!card) return;
        var itemId = card.getAttribute('data-item-id');
        if (!itemId) return;

        if (btn.closest('.dc-overflow-menu')) {
            closeOverflowMenu();
        }

        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch('/dashboard/unarchive', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ id: itemId })
        })
        .then(function (res) {
            if (!res.ok) throw new Error('Restore failed');
            return res.json();
        })
        .then(function () {
            var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            // Capture section context before removing card
            var section = card.closest('.dash-section');
            var countEl = section ? section.querySelector('.dash-section-count') : null;
            var feedItem = card.closest('.dash-feed-item');
            var nextFeedItem = feedItem && feedItem.nextElementSibling;
            var sectionSummary = section && section.querySelector('summary');

            function removeAndUpdate() {
                if (feedItem) feedItem.remove(); else card.style.display = 'none';

                // Decrement archived section count
                if (countEl) {
                    var current = parseInt(countEl.textContent, 10);
                    if (!isNaN(current) && current > 0) {
                        countEl.textContent = String(current - 1);
                    }
                }

                // If section is now empty, remove it or show empty state
                if (section) {
                    var remaining = section.querySelectorAll('.dash-feed-item');
                    if (remaining.length === 0) {
                        section.style.transition = 'opacity 0.25s ease';
                        section.style.opacity = '0';
                        section.addEventListener('transitionend', function () { section.remove(); }, { once: true });
                    }
                }

                // Move focus for keyboard users
                var focusTarget = null;
                if (nextFeedItem) {
                    focusTarget = nextFeedItem.querySelector('.dc-quick-actions button, .dc a[href]') || nextFeedItem.querySelector('.dc');
                }
                if (!focusTarget && sectionSummary) focusTarget = sectionSummary;
                if (focusTarget && typeof focusTarget.focus === 'function') {
                    if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
                    focusTarget.focus({ preventScroll: true });
                }
            }

            if (prefersReducedMotion) {
                removeAndUpdate();
            } else {
                card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                card.style.opacity = '0';
                card.style.transform = 'translateX(40px)';
                card.addEventListener('transitionend', removeAndUpdate, { once: true });
            }

            trackEvent('item_restored', {});
            toast.success('Back in your ' + getDashboardBriefNoun());
        })
        .catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            toast.error("Couldn't restore this item. Please try again.");
        });
    });

    var focusedStateResizeTimer = null;
    window.addEventListener('resize', function () {
        if (focusedStateResizeTimer) {
            window.clearTimeout(focusedStateResizeTimer);
        }

        focusedStateResizeTimer = window.setTimeout(function () {
            // Mobile browsers fire resize when the URL bar shows/hides during scroll; re-running
            // syncFocusedDigestSections would reset <details> sections and fight the user's toggles.
            // Only re-sync when crossing the compact breakpoint (width), not on every resize.
            var isCompactMode = applyFocusedDigestCardLayout();
            if (isCompactMode === null) return;
            if (focusedDigestLayoutCompactMode !== isCompactMode) {
                focusedDigestLayoutCompactMode = isCompactMode;
                syncFocusedDigestSections(isCompactMode);
            }
        }, 120);
    });

    var feedTarget = document.getElementById('dash-feed-target');
    if (feedTarget && window.Stackora && typeof window.Stackora.applyDashboardFeedDomEnhancements === 'function') {
        window.Stackora.applyDashboardFeedDomEnhancements(feedTarget);
    } else {
        initFocusedDashboardState();
        initDashboardInsights();
    }
}

function initFormEventTracking() {
    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
        if (form.id === 'dash-search-form') return; // tracked by initDashboardSearch
        if (form.classList.contains('settings-form')) return; // tracked by initSettingsAjaxForms
        var action = (form.getAttribute('action') || '').split('?')[0] || '';
        if (action.indexOf('/settings/account/delete') !== -1) {
            var confirmationInput = form.querySelector('input[name="confirmation"]');
            var confirmation = confirmationInput && confirmationInput.value ? confirmationInput.value.trim() : '';
            if (confirmation === 'DELETE') {
                trackEvent('account_deletion_requested', {});
            }
            return;
        }
        if (action.indexOf('/Settings/') !== -1) {
            var section = action.split('/').filter(Boolean).pop() || 'settings';
            trackEvent('settings_saved', { section: section });
        }
    });
}

function initSignInTracking() {
    var pathname = window.location.pathname || '/';
    var path = pathname.replace(/\/$/, '') || '/';
    if (path !== '/' && path !== '/dashboard') return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('from') !== 'signin') return;
    trackEvent('login', { method: 'magic_link' });
    params.delete('from');
    var cleanSearch = params.toString();
    var newUrl = pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
}

function getDashboardActiveView() {
    var activeTab = document.querySelector('.dash-view-tab--active');
    return (activeTab && activeTab.getAttribute('data-view')) || 'digest';
}

function dashboardSupportsDigestBucketFilters() {
    return !!document.querySelector('.dash--focused[data-dashboard-variant="focused"]');
}

function normalizeDashboardBucketFilter(bucket) {
    if (!dashboardSupportsDigestBucketFilters()) return 'all';
    return bucket === 'attention' || bucket === 'updates' ? bucket : 'all';
}

function getDashboardActiveBucketFilter() {
    var searchParams = new URLSearchParams(window.location.search);
    return normalizeDashboardBucketFilter((searchParams.get('bucket') || '').trim());
}

function getDashboardSearchQuery() {
    var searchParams = new URLSearchParams(window.location.search);
    return (searchParams.get('q') || '').trim();
}

function buildDashboardFeedUrl(view, query, bucket) {
    var params = [];
    var normalizedView = view || 'digest';
    var normalizedQuery = (query || '').trim();
    var normalizedBucket = normalizeDashboardBucketFilter(typeof bucket === 'undefined' ? getDashboardActiveBucketFilter() : bucket);
    if (normalizedQuery) params.push('q=' + encodeURIComponent(normalizedQuery));
    if (normalizedView === 'actions') params.push('filter=actions');
    if (normalizedView === 'archived') params.push('filter=archived');
    if (normalizedView === 'all') params.push('filter=all');
    if (normalizedView === 'digest' && normalizedBucket !== 'all') {
        params.push('bucket=' + encodeURIComponent(normalizedBucket));
    }
    return params.length ? '/dashboard/feed?' + params.join('&') : '/dashboard/feed';
}

function buildDashboardFeedChromeUrl(view, query, bucket) {
    var params = [];
    var normalizedView = view || 'digest';
    var normalizedQuery = (query || '').trim();
    var normalizedBucket = normalizeDashboardBucketFilter(typeof bucket === 'undefined' ? getDashboardActiveBucketFilter() : bucket);
    if (normalizedQuery) params.push('q=' + encodeURIComponent(normalizedQuery));
    if (normalizedView === 'actions') params.push('filter=actions');
    if (normalizedView === 'archived') params.push('filter=archived');
    if (normalizedView === 'all') params.push('filter=all');
    if (normalizedView === 'digest' && normalizedBucket !== 'all') {
        params.push('bucket=' + encodeURIComponent(normalizedBucket));
    }
    return params.length ? '/dashboard/feed-chrome?' + params.join('&') : '/dashboard/feed-chrome';
}

function getDashboardSearchUiElements() {
    var form = document.getElementById('dash-search-form');
    if (!form) return null;

    return {
        form: form,
        input: form.querySelector('#dash-q'),
        shell: form.querySelector('[data-dash-search-shell]'),
        badge: form.querySelector('[data-dash-search-badge]'),
        clearLink: form.querySelector('[data-dash-clear-search]'),
        termEl: form.querySelector('[data-dash-search-term]'),
        submitButton: form.querySelector('.dash-search-submit'),
        loadingState: form.querySelector('[data-dash-loading-state]'),
        loadingLabel: form.querySelector('[data-dash-loading-label]')
    };
}

function syncDashboardSearchUi(query, options) {
    var elements = getDashboardSearchUiElements();
    if (!elements) return;

    options = options || {};

    var normalizedQuery = (query || '').trim();
    var hasQuery = normalizedQuery.length > 0;
    var isLoading = options.isLoading === true;
    var loadingMessage = (options.loadingMessage || '').trim() || 'Refreshing your ' + getDashboardBriefNoun();

    if (elements.input && elements.input.value !== normalizedQuery) {
        elements.input.value = normalizedQuery;
    }

    if (elements.shell) {
        elements.shell.classList.toggle('dash-search-shell--filtered', hasQuery);
        elements.shell.classList.toggle('is-loading', isLoading);
        elements.shell.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (elements.badge) {
        elements.badge.hidden = hasQuery || isLoading;
    }

    if (elements.clearLink) {
        elements.clearLink.hidden = !hasQuery;
    }

    if (elements.termEl) {
        elements.termEl.textContent = normalizedQuery;
    }

    if (elements.loadingState) {
        elements.loadingState.hidden = !isLoading;
    }

    if (elements.loadingLabel) {
        elements.loadingLabel.textContent = loadingMessage;
    }

    if (elements.submitButton) {
        elements.submitButton.disabled = isLoading;
    }
}

function getDashboardBriefNoun() {
    var el = document.querySelector('[data-brief-noun]');
    var noun = el && el.getAttribute('data-brief-noun');
    return (noun && noun.trim()) || 'digest';
}

// Page-URL base for dashboard history writes. The feed lives on /dashboard/brief but Home is
// /dashboard; the feed FETCH endpoints stay page-agnostic. Absent attribute → /dashboard (Home).
function getDashboardBasePath() {
    var el = document.querySelector('[data-dash-base-path]');
    var p = el && el.getAttribute('data-dash-base-path');
    return (p && p.trim()) || '/dashboard';
}

function getDashboardLoadingMessage(options) {
    options = options || {};

    var reason = options.reason || 'refresh';
    var view = options.view || 'digest';
    var query = (options.query || '').trim();
    var bucket = normalizeDashboardBucketFilter(typeof options.bucket === 'undefined' ? getDashboardActiveBucketFilter() : options.bucket);

    if (reason === 'initial') {
        return 'Getting your ' + getDashboardBriefNoun() + ' ready';
    }

    if (reason === 'retry') {
        return 'Trying again';
    }

    if (reason === 'search') {
        return view === 'all' ? 'Searching your history' : 'Searching your ' + getDashboardBriefNoun();
    }

    if (reason === 'clear-search') {
        return 'Clearing search';
    }

    if (reason === 'view') {
        if (view === 'actions') return 'Loading your actions';
        if (view === 'archived') return 'Loading set aside';
        if (view === 'all') return query ? 'Searching your history' : 'Loading your history';
        return query ? 'Refreshing results' : 'Getting your ' + getDashboardBriefNoun() + ' ready';
    }

    if (reason === 'bucket') {
        if (bucket === 'attention') return query ? 'Searching attention items' : 'Focusing on attention';
        if (bucket === 'updates') return query ? 'Searching updates' : 'Showing updates';
        return query ? 'Searching all items' : 'Showing everything';
    }

    if (view === 'actions') return 'Loading your actions';
    if (view === 'archived') return 'Loading set aside';
    if (view === 'all') return query ? 'Searching your history' : 'Loading your history';
    return query ? 'Refreshing results' : 'Refreshing your ' + getDashboardBriefNoun();
}

var dashboardFeedRefreshSeq = 0;
var dashboardFeedAbortController = null;
var dashboardFeedChromeRefreshSeq = 0;
var dashboardFeedChromeAbortController = null;
var dashboardLiveShellRefreshSeq = 0;
var dashboardLiveShellAbortController = null;

function buildDashboardPageUrl(view, query, bucket) {
    var params = [];
    var normalizedView = view || 'digest';
    var normalizedQuery = (query || '').trim();
    var normalizedBucket = normalizeDashboardBucketFilter(typeof bucket === 'undefined' ? getDashboardActiveBucketFilter() : bucket);
    if (normalizedQuery) params.push('q=' + encodeURIComponent(normalizedQuery));
    if (normalizedView === 'actions' || normalizedView === 'archived' || normalizedView === 'all') params.push('view=' + encodeURIComponent(normalizedView));
    if (normalizedView === 'digest' && normalizedBucket !== 'all') {
        params.push('bucket=' + encodeURIComponent(normalizedBucket));
    }
    var base = getDashboardBasePath();
    return params.length ? base + '?' + params.join('&') : base;
}

function syncDashboardSearchVisibility(view) {
    var searchForm = document.getElementById('dash-search-form');
    if (searchForm) {
        searchForm.style.display = view === 'actions' ? 'none' : '';
    }
}

function getDashboardSearchScopeLabel(view) {
    if (view === 'all') return 'All history';
    return 'This ' + getDashboardBriefNoun();
}

function getDashboardSearchLabel(view) {
    if (view === 'all') return 'Find anything in your history';
    return 'Find anything in your ' + getDashboardBriefNoun();
}

function getDashboardSearchPlaceholder(view) {
    if (view === 'all') return 'Search all history...';
    return 'Search senders, summaries, actions...';
}

function syncDashboardSearchScope(view) {
    var normalizedView = view || 'digest';

    var badge = document.querySelector('[data-dash-search-badge]');
    if (badge) badge.textContent = getDashboardSearchScopeLabel(normalizedView);

    var label = document.querySelector('[data-dash-search-label]');
    if (label) label.textContent = getDashboardSearchLabel(normalizedView);

    var input = document.getElementById('dash-q');
    if (input) input.placeholder = getDashboardSearchPlaceholder(normalizedView);
}

function setDashboardActiveView(view) {
    document.querySelectorAll('.dash-view-tab').forEach(function (tab) {
        var tabView = tab.getAttribute('data-view') || 'digest';
        var isActive = tabView === (view || 'digest');
        tab.classList.toggle('dash-view-tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
}

function syncDashboardBucketControls(bucket) {
    var normalizedBucket = normalizeDashboardBucketFilter(bucket);
    document.querySelectorAll('[data-dash-bucket-filter]').forEach(function (button) {
        var buttonBucket = normalizeDashboardBucketFilter(button.getAttribute('data-dash-bucket-filter') || 'all');
        var isActive = buttonBucket === normalizedBucket;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
}

function tryDigestExpandHaptic() {
    try {
        if (typeof navigator === 'undefined' || !navigator.vibrate) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        navigator.vibrate(10);
    } catch (e) { /* ignore */ }
}

function setFocusedCardExpanded(card, expanded) {
    if (!card) return;

    card.classList.toggle('dc--expanded', expanded);

    var toggle = card.querySelector('.js-dc-mobile-toggle');
    if (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        var title = toggle.querySelector('.dc-mobile-toggle-title');
        if (title) {
            title.textContent = expanded ? 'Hide summary' : 'Expand summary';
        }
    }
}

/** Last known compact-layout state for focused digest; used to avoid re-applying section open/close on every resize. */
var focusedDigestLayoutCompactMode = null;

/**
 * Updates digest card compact UI (mobile expand control) for the focused dashboard.
 * @returns {boolean|null} compact mode when the focused digest is active, otherwise null
 */
function applyFocusedDigestCardLayout() {
    if (!dashboardSupportsDigestBucketFilters()) return null;

    var isCompactMode = window.matchMedia('(max-width: 980px)').matches;
    document.querySelectorAll('.dash--focused .dc').forEach(function (card) {
        var toggle = card.querySelector('.js-dc-mobile-toggle');
        if (!toggle) return;

        if (isCompactMode) {
            toggle.hidden = false;
            card.classList.add('dc--compact');
            setFocusedCardExpanded(card, card.dataset.mobileExpanded === 'true');
        } else {
            toggle.hidden = true;
            card.classList.remove('dc--compact');
            card.classList.remove('dc--expanded');
            delete card.dataset.mobileExpanded;
            setFocusedCardExpanded(card, false);
        }
    });
    return isCompactMode;
}

function syncFocusedDigestSections(isCompactMode) {
    if (!dashboardSupportsDigestBucketFilters()) return;

    var bucket = getDashboardActiveBucketFilter();
    var attention = document.querySelector('[data-digest-section="attention"]');
    var updates = document.querySelector('[data-digest-section="updates"]');
    var muted = document.querySelector('[data-digest-section="muted"]');

    if (!isCompactMode) {
        [attention, updates, muted].forEach(function (section) {
            if (section) section.open = true;
        });
        return;
    }

    if (bucket === 'attention') {
        if (attention) attention.open = true;
        if (updates) updates.open = false;
        if (muted) muted.open = false;
        return;
    }

    if (bucket === 'updates') {
        if (attention) attention.open = false;
        if (updates) updates.open = true;
        if (muted) muted.open = false;
        return;
    }

    if (attention) attention.open = true;
    if (updates) updates.open = attention ? false : true;
    if (muted) muted.open = false;
}

function initFocusedDashboardState() {
    if (!dashboardSupportsDigestBucketFilters()) return;

    syncDashboardBucketControls(getDashboardActiveBucketFilter());

    var isCompactMode = applyFocusedDigestCardLayout();
    if (isCompactMode === null) return;
    focusedDigestLayoutCompactMode = isCompactMode;
    syncFocusedDigestSections(isCompactMode);
}

window.Stackora = window.Stackora || {};
window.Stackora.getDashboardLoadingMessage = getDashboardLoadingMessage;
window.Stackora.syncDashboardSearchUi = syncDashboardSearchUi;
window.Stackora.initFocusedDashboardState = initFocusedDashboardState;
window.Stackora.bindDashboardInteractiveRegions = bindDashboardInteractiveRegions;
window.Stackora.refreshDashboardFeed = function () {
    var target = document.getElementById('dash-feed-target');
    if (!target) return;
    var view = getDashboardActiveView();
    var query = getDashboardSearchQuery();
    dashboardFeedRefreshSeq += 1;
    var seq = dashboardFeedRefreshSeq;
    if (dashboardFeedAbortController) {
        dashboardFeedAbortController.abort();
    }
    dashboardFeedAbortController = new AbortController();
    target.setAttribute('aria-busy', 'true');
    beginDashboardFeedLoading(target);
    fetch(buildDashboardFeedUrl(view, query), { credentials: 'same-origin', signal: dashboardFeedAbortController.signal })
        .then(function (response) {
            if (!response.ok) throw new Error();
            return response.text();
        })
        .then(function (html) {
            if (seq !== dashboardFeedRefreshSeq) return;
            replaceDashboardFeedFromHtml(target, html);
        })
        .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (seq === dashboardFeedRefreshSeq) {
                endDashboardFeedLoading(target);
            }
            trackEvent('dashboard_feed_refresh_failed', { scope: 'full' });
        });
};
window.Stackora.refreshDashboardFeedChrome = function () {
    var target = document.getElementById('dash-feed-target');
    if (!target) return;
    var view = getDashboardActiveView();
    if (view === 'actions') {
        window.Stackora.refreshDashboardFeed();
        return;
    }
    var query = getDashboardSearchQuery();
    dashboardFeedChromeRefreshSeq += 1;
    var seq = dashboardFeedChromeRefreshSeq;
    if (dashboardFeedChromeAbortController) {
        dashboardFeedChromeAbortController.abort();
    }
    dashboardFeedChromeAbortController = new AbortController();
    fetch(buildDashboardFeedChromeUrl(view, query), { credentials: 'same-origin', signal: dashboardFeedChromeAbortController.signal })
        .then(function (response) {
            if (response.status === 404) {
                window.Stackora.refreshDashboardFeed();
                throw new Error('feed_chrome_fallback');
            }
            if (!response.ok) throw new Error();
            return response.text();
        })
        .then(function (html) {
            if (seq !== dashboardFeedChromeRefreshSeq) return;
            replaceDashboardChromeFromHtml(target, html);
        })
        .catch(function (err) {
            if (err && err.message === 'feed_chrome_fallback') return;
            if (err && err.name === 'AbortError') return;
            if (seq === dashboardFeedChromeRefreshSeq) {
                trackEvent('dashboard_feed_refresh_failed', { scope: 'chrome' });
            }
        });
};

window.Stackora.refreshDashboardLiveShell = function () {
    var classicRegion = document.getElementById('dash-classic-usage-region');
    var sidebarUtilitiesRegion = document.getElementById('dash-sidebar-utilities-region');
    var usageAlertRegion = document.getElementById('dash-usage-alert-region');
    if (!classicRegion && !sidebarUtilitiesRegion && !usageAlertRegion) {
        return;
    }

    dashboardLiveShellRefreshSeq += 1;
    var seq = dashboardLiveShellRefreshSeq;
    if (dashboardLiveShellAbortController) {
        dashboardLiveShellAbortController.abort();
    }

    dashboardLiveShellAbortController = new AbortController();
    fetch('/dashboard/live-shell', { credentials: 'same-origin', signal: dashboardLiveShellAbortController.signal })
        .then(function (response) {
            if (!response.ok) throw new Error();
            return response.text();
        })
        .then(function (html) {
            if (seq !== dashboardLiveShellRefreshSeq) return;
            replaceDashboardLiveShellFromHtml(html);
        })
        .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (seq === dashboardLiveShellRefreshSeq) {
                trackEvent('dashboard_feed_refresh_failed', { scope: 'live_shell' });
            }
        });
};

window.Stackora.refreshDashboardStatusRegion = function () {
    var target = document.getElementById('dash-status-region');
    if (!target) return;
    fetch('/dashboard/status-region', { credentials: 'same-origin' })
        .then(function (response) {
            if (!response.ok) throw new Error();
            return response.text();
        })
        .then(function (html) {
            target.innerHTML = html;
            // The dashboard no longer renders any [data-send-test-email] button (moved to Settings) — this
            // hidden marker div is now inert on this page; just drop it rather than leave it in the DOM.
            var hint = target.querySelector('#dash-forwarding-cta-hint');
            if (hint) hint.remove();
            bindDashboardInteractiveRegions(target);
            if (window.Stackora.signalr && typeof window.Stackora.signalr.syncProcessingBanner === 'function') {
                window.Stackora.signalr.syncProcessingBanner();
            }
        })
        .catch(function () {
            /* no-op */
        });
};

function getDashboardFeedLoadingOverlayHtml() {
    var card =
        '<div class="dash-feed-skeleton-card">' +
        '<div class="dash-feed-skeleton-header">' +
        '<span class="ui-skeleton" style="width:6ch;height:0.7em;border-radius:4px"></span>' +
        '<span class="ui-skeleton" style="width:8ch;height:0.65em"></span>' +
        '</div>' +
        '<div class="dash-feed-skeleton-body">' +
        '<span class="ui-skeleton ui-skeleton-text" style="width:80%"></span>' +
        '<span class="ui-skeleton ui-skeleton-text" style="width:60%"></span>' +
        '</div>' +
        '</div>';
    return (
        '<div class="dash-feed-loading-overlay" aria-hidden="true">' +
        '<div class="dash-feed-skeleton dash-feed-skeleton--overlay" aria-label="Loading ' + getDashboardBriefNoun() + ' items">' +
        card +
        card +
        card +
        '</div></div>'
    );
}

function beginDashboardFeedLoading(target) {
    if (!target) return;
    if (target.querySelector('.dash-feed-loading-overlay')) return;
    target.classList.add('dash-feed-target--loading');
    target.insertAdjacentHTML('beforeend', getDashboardFeedLoadingOverlayHtml());
}

function endDashboardFeedLoading(target) {
    if (!target) return;
    target.classList.remove('dash-feed-target--loading');
    var overlay = target.querySelector('.dash-feed-loading-overlay');
    if (overlay) overlay.remove();
    target.setAttribute('aria-busy', 'false');
}

function replaceDashboardFeedFromHtml(target, html) {
    if (target) {
        target.classList.remove('dash-feed-target--loading');
    }
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var liveAside = temp.querySelector('#dash-hero-aside-live');
    var currentAside = document.querySelector('.dash-hero-aside');
    if (liveAside && currentAside) {
        liveAside.removeAttribute('id');
        currentAside.replaceWith(liveAside);
    }

    var liveNext = temp.querySelector('#dash-next-live');
    var currentNext = document.querySelector('.dash-brief .dash-next');
    if (liveNext && currentNext) {
        liveNext.removeAttribute('id');
        currentNext.replaceWith(liveNext);
    }

    var heroAside = temp.querySelector('#dash-hero-aside-live');
    if (heroAside) heroAside.remove();
    var nextEl = temp.querySelector('#dash-next-live');
    if (nextEl) nextEl.remove();

    target.setAttribute('aria-busy', 'false');
    target.classList.add('dash-feed-reveal');
    target.innerHTML = temp.innerHTML;

    if (window.Stackora && typeof window.Stackora.applyDashboardFeedDomEnhancements === 'function') {
        window.Stackora.applyDashboardFeedDomEnhancements(target);
    } else {
        bindDashboardInteractiveRegions(target);
        initDashboardInsights();
        initFocusedDashboardState();
        applyDashboardTestEmailSessionLock();
        syncDashboardSearchUi(getDashboardSearchQuery(), { isLoading: false });
    }
}

function replaceDashboardChromeFromHtml(target, html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var liveAside = temp.querySelector('#dash-hero-aside-live');
    var currentAside = document.querySelector('.dash-hero-aside');
    if (liveAside && currentAside) {
        liveAside.removeAttribute('id');
        currentAside.replaceWith(liveAside);
    }

    var liveNext = temp.querySelector('#dash-next-live');
    var currentNext = document.querySelector('.dash-brief .dash-next');
    if (liveNext && currentNext) {
        liveNext.removeAttribute('id');
        currentNext.replaceWith(liveNext);
    }

    var heroAside = temp.querySelector('#dash-hero-aside-live');
    if (heroAside) heroAside.remove();
    var nextEl = temp.querySelector('#dash-next-live');
    if (nextEl) nextEl.remove();

    var newInline = temp.querySelector('#dash-feed-inline-chrome');
    var oldInline = document.querySelector('#dash-feed-inline-chrome');
    if (newInline && oldInline) {
        oldInline.replaceWith(newInline);
    } else {
        window.Stackora.refreshDashboardFeed();
        return;
    }

    if (window.Stackora && typeof window.Stackora.applyDashboardFeedDomEnhancements === 'function') {
        window.Stackora.applyDashboardFeedDomEnhancements(target);
    } else {
        bindDashboardInteractiveRegions(target);
        initDashboardInsights();
        initFocusedDashboardState();
        applyDashboardTestEmailSessionLock();
        syncDashboardSearchUi(getDashboardSearchQuery(), { isLoading: false });
    }
    if (window.Stackora.signalr && typeof window.Stackora.signalr.syncProcessingBanner === 'function') {
        window.Stackora.signalr.syncProcessingBanner();
    }
}

function replaceDashboardLiveShellFromHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var classicRegion = document.getElementById('dash-classic-usage-region');
    var liveClassic = temp.querySelector('#dash-classic-usage-live');
    if (classicRegion && liveClassic) {
        classicRegion.innerHTML = liveClassic.innerHTML;
        bindDashboardInteractiveRegions(classicRegion);
    }

    var liveUtilities = temp.querySelector('#dash-utilities-live');
    var sidebarUtilitiesRegion = document.getElementById('dash-sidebar-utilities-region');
    if (sidebarUtilitiesRegion && liveUtilities) {
        sidebarUtilitiesRegion.innerHTML = liveUtilities.innerHTML;
        bindDashboardInteractiveRegions(sidebarUtilitiesRegion);
    }

    var usageAlertRegion = document.getElementById('dash-usage-alert-region');
    if (usageAlertRegion) {
        var liveUsageAlert = temp.querySelector('#dash-usage-alert-live');
        usageAlertRegion.innerHTML = liveUsageAlert ? liveUsageAlert.innerHTML : '';
        bindDashboardInteractiveRegions(usageAlertRegion);
    }

    applyDashboardTestEmailSessionLock();
}

// ═══════════════════════════════════════════════════════════════
// Dashboard: AJAX search
// ═══════════════════════════════════════════════════════════════

function initDashboardSearch() {
    var form = document.getElementById('dash-search-form');
    if (!form) return;
    if (document.querySelector('[data-dashboard-async-feed="true"]')) return;

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        var input = form.querySelector('#dash-q');
        var q = (input ? input.value : '').trim();
        if (!q) return;

        var target = document.getElementById('dash-feed-target');
        if (!target) { form.submit(); return; }

        var loaderBar = document.querySelector('.dash-loader-bar');
        if (loaderBar) loaderBar.classList.add('dash-loader-bar--visible');

        target.setAttribute('aria-busy', 'true');
        beginDashboardFeedLoading(target);

        var view = getDashboardActiveView();
        syncDashboardSearchUi(q, {
            isLoading: true,
            loadingMessage: getDashboardLoadingMessage({ reason: 'search', view: view, query: q })
        });
        var nextUrl = buildDashboardPageUrl(view, q);
        if (window.location.pathname + window.location.search !== nextUrl) {
            window.history.replaceState({}, '', nextUrl);
        }

        fetch(buildDashboardFeedUrl(view, q), { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.text();
            })
            .then(function (html) {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                replaceDashboardFeedFromHtml(target, html);
            })
            .catch(function () {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                endDashboardFeedLoading(target);
                syncDashboardSearchUi(q, { isLoading: false });
                toast.error("Couldn't search. Please try again.");
            });

        trackEvent('dashboard_search', { query_length: q.length });
    });

    // AJAX clear search
    document.addEventListener('click', function (e) {
        var clearBtn = e.target.closest('[data-dash-clear-search]');
        if (!clearBtn) return;
        e.preventDefault();

        var input = form.querySelector('#dash-q');
        if (input) input.value = '';

        var target = document.getElementById('dash-feed-target');
        if (!target) { window.location.href = '/dashboard'; return; }

        var loaderBar = document.querySelector('.dash-loader-bar');
        if (loaderBar) loaderBar.classList.add('dash-loader-bar--visible');

        target.setAttribute('aria-busy', 'true');
        beginDashboardFeedLoading(target);

        var view = getDashboardActiveView();
        syncDashboardSearchUi('', {
            isLoading: true,
            loadingMessage: getDashboardLoadingMessage({ reason: 'clear-search', view: view, query: '', bucket: 'all' })
        });
        var nextUrl = buildDashboardPageUrl(view, '');
        if (window.location.pathname + window.location.search !== nextUrl) {
            window.history.replaceState({}, '', nextUrl);
        }

        fetch(buildDashboardFeedUrl(view, ''), { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error();
                return res.text();
            })
            .then(function (html) {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                replaceDashboardFeedFromHtml(target, html);
            })
            .catch(function () {
                if (loaderBar) loaderBar.classList.remove('dash-loader-bar--visible');
                endDashboardFeedLoading(target);
                syncDashboardSearchUi('', { isLoading: false });
                toast.error("Couldn't clear search. Please try again.");
            });
    });
}

// ═══════════════════════════════════════════════════════════════
// Action Items
// ═══════════════════════════════════════════════════════════════

function initActionItemsUi() {
    function toDateInputValue(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    function applyDateShortcut(input, action) {
        if (!input) return;

        var nextDate = new Date();
        if (action === 'today') {
            input.value = toDateInputValue(nextDate);
        } else if (action === 'tomorrow') {
            nextDate.setDate(nextDate.getDate() + 1);
            input.value = toDateInputValue(nextDate);
        } else if (action === 'nextweek') {
            nextDate.setDate(nextDate.getDate() + 7);
            input.value = toDateInputValue(nextDate);
        }

        syncComposeReminder(input);
    }

    function syncComposeReminder(dateInput) {
        var reminderSelect = document.getElementById('ai-add-reminder');
        if (!reminderSelect) return;
        if (dateInput && dateInput.value) {
            if (reminderSelect.value === 'None') {
                reminderSelect.value = 'SameDayMorning';
            }
        } else {
            reminderSelect.value = 'None';
        }
    }

    function toggleActionEdit(item, shouldOpen) {
        if (!item) return;
        var editPanel = item.querySelector('.ai-edit');
        if (!editPanel) return;

        editPanel.hidden = !shouldOpen;
        item.classList.toggle('ai-item--editing', shouldOpen);

        if (shouldOpen) {
            var titleInput = item.querySelector('.js-ai-edit-title');
            if (titleInput) {
                titleInput.focus();
                if (typeof titleInput.select === 'function') {
                    titleInput.select();
                }
            }
        }
    }

    function createActionItem() {
        var input = document.getElementById('ai-add-input');
        var addBtn = document.querySelector('.js-ai-add');
        var dateInput = document.getElementById('ai-add-date');
        var reminderInput = document.getElementById('ai-add-reminder');
        var title = input && input.value ? input.value.trim() : '';

        if (!title) {
            if (input) input.focus();
            return;
        }

        if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }

        // No "Add to" UI: default undated manual items to Today (prior compose default). Server derives bucket from due date when set.
        var hasDueDate = dateInput && dateInput.value;
        var bucketForCreate = hasDueDate ? null : 'Today';

        fetch('/dashboard/actions', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({
                title: title,
                dueDate: dateInput && dateInput.value ? dateInput.value : null,
                reminderPolicy: reminderInput && reminderInput.value ? reminderInput.value : null,
                bucket: bucketForCreate,
                source: 'manual'
            })
        })
        .then(function (res) {
            if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (data) {
                    throw new Error(data.error || '');
                });
            }
            return res.json();
        })
        .then(function () {
            if (input) input.value = '';
            if (dateInput) dateInput.value = '';
            if (reminderInput) reminderInput.value = 'None';
            if (addBtn) addBtn.disabled = true;
            addBtn && addBtn.classList.remove('is-loading');
            // Collapse compose details after adding
            var compose = document.querySelector('.ai-compose');
            if (compose) compose.classList.remove('is-expanded');
            reloadActionsTab();
            toast.success('Action added');
            trackEvent('action_created', { source: 'manual' });
        })
        .catch(function (err) {
            if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
            toast.error(err.message || "Couldn't add action. Please try again.");
        });
    }

    function saveActionItem(item) {
        if (!item) return;

        var id = item.getAttribute('data-action-id');
        var titleInput = item.querySelector('.js-ai-edit-title');
        var dateInput = item.querySelector('.js-ai-edit-date');
        var reminderInput = item.querySelector('.js-ai-edit-reminder');
        var saveBtn = item.querySelector('.js-ai-save');
        var title = titleInput && titleInput.value ? titleInput.value.trim() : '';

        if (!id) return;
        if (!title) {
            toast.error('Add a short title before saving.');
            if (titleInput) titleInput.focus();
            return;
        }

        if (saveBtn) { saveBtn.disabled = true; saveBtn.classList.add('is-loading'); }

        fetch('/dashboard/actions/update', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({
                id: id,
                title: title,
                dueDate: dateInput && dateInput.value ? dateInput.value : null,
                reminderPolicy: reminderInput && reminderInput.value ? reminderInput.value : null,
                bucket: null
            })
        })
        .then(function (res) {
            if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (data) {
                    throw new Error(data.error || '');
                });
            }
            return res.json();
        })
        .then(function () {
            reloadActionsTab();
            toast.success('Action updated');
        })
        .catch(function (err) {
            if (saveBtn) { saveBtn.disabled = false; saveBtn.classList.remove('is-loading'); }
            toast.error(err.message || "Couldn't update action. Please try again.");
        });
    }

    function bumpDashboardActionCount() {
        var statusItems = document.querySelectorAll('.dash-hero-status-item');
        statusItems.forEach(function (item) {
            var label = item.querySelector('.dash-hero-status-label');
            var value = item.querySelector('.dash-hero-status-value');
            if (!label || !value) return;
            if ((label.textContent || '').trim().toLowerCase() !== 'actions') return;

            var current = parseInt(value.textContent || '0', 10);
            if (!isNaN(current)) {
                value.textContent = String(current + 1);
            }
        });
    }

    document.addEventListener('input', function (e) {
        if (e.target.id !== 'ai-add-input') return;
        var btn = document.querySelector('.js-ai-add');
        if (btn) btn.disabled = !e.target.value.trim();

        // Expand compose details when text is entered
        var compose = e.target.closest('.ai-compose');
        if (compose && e.target.value.trim()) {
            compose.classList.add('is-expanded');
        }
    });

    // Expand compose on input focus
    document.addEventListener('focusin', function (e) {
        if (e.target.id !== 'ai-add-input') return;
        var compose = e.target.closest('.ai-compose');
        if (compose) compose.classList.add('is-expanded');
    });

    // Collapse compose when focus leaves the form and input is empty
    document.addEventListener('focusout', function (e) {
        var compose = e.target.closest('.ai-compose');
        if (!compose) return;
        // 250ms allows iOS WKWebView's two-tick focus handoff to settle before checking activeElement
        setTimeout(function () {
            if (compose.contains(document.activeElement)) return;
            var input = document.getElementById('ai-add-input');
            if (input && !input.value.trim()) {
                compose.classList.remove('is-expanded');
            }
        }, 250);
    });

    document.addEventListener('change', function (e) {
        if (e.target.id === 'ai-add-date') {
            syncComposeReminder(e.target);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.target.id === 'ai-add-input') {
            if (e.key === 'Enter' && e.target.value.trim()) {
                e.preventDefault();
                createActionItem();
            }
            return;
        }

        if (e.key === 'Escape') {
            var escapeItem = e.target.closest('.ai-item');
            if (escapeItem && escapeItem.classList.contains('ai-item--editing')) {
                toggleActionEdit(escapeItem, false);
            }
            return;
        }

        if (e.key !== 'Enter' || !e.target.classList.contains('js-ai-edit-title')) return;
        e.preventDefault();
        saveActionItem(e.target.closest('.ai-item'));
    });

    document.addEventListener('click', function (e) {
        var addBtn = e.target.closest('.js-ai-add');
        if (addBtn) {
            createActionItem();
            return;
        }

        var dateChip = e.target.closest('.js-ai-date-chip');
        if (dateChip) {
            var shell = dateChip.closest('.ai-date-row');
            var dateInput = shell && shell.querySelector('.js-ai-date-input');
            applyDateShortcut(dateInput, dateChip.getAttribute('data-date-action'));
            return;
        }

        var openEdit = e.target.closest('.js-ai-open-edit');
        if (openEdit) {
            toggleActionEdit(openEdit.closest('.ai-item'), true);
            return;
        }

        var cancelEdit = e.target.closest('.js-ai-cancel-edit');
        if (cancelEdit) {
            toggleActionEdit(cancelEdit.closest('.ai-item'), false);
            return;
        }

        var saveEdit = e.target.closest('.js-ai-save');
        if (saveEdit) {
            saveActionItem(saveEdit.closest('.ai-item'));
        }
    });

    // ── Pending undo timers (keyed by action item ID) ──
    var pendingUndos = {};
    var pendingUndoActions = {}; // stores { url, body } for each pending undo

    // Flush all pending undo actions on page unload so server state stays consistent.
    window.addEventListener('beforeunload', function () {
        Object.keys(pendingUndoActions).forEach(function (id) {
            if (pendingUndos[id]) clearTimeout(pendingUndos[id]);
            var action = pendingUndoActions[id];
            if (action) {
                navigator.sendBeacon(action.url, new Blob([action.body], { type: 'application/json' }));
            }
        });
        pendingUndos = {};
        pendingUndoActions = {};
    });

    function slideOutItem(item, direction) {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;
        item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        item.style.opacity = '0';
        item.style.transform = 'translateX(' + direction + 'px)';
    }

    function revertSlideOut(item) {
        item.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        item.style.opacity = '';
        item.style.transform = '';
    }

    function parseActionBool(item, name) {
        return (item.getAttribute(name) || '').toLowerCase() === 'true';
    }

    function parseActionCompletedAt(item) {
        var value = item.getAttribute('data-action-completed-at');
        if (!value) return null;

        var parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
    }

    function adjustCountValue(el, delta) {
        if (!el || !delta) return;

        var current = parseInt(el.textContent || '0', 10);
        if (isNaN(current)) return;

        el.textContent = String(Math.max(0, current + delta));
    }

    function adjustActionHeroMetrics(deltas) {
        if (!deltas) return;

        adjustCountValue(document.querySelector('.dash-hero-counter-num'), deltas.pending || 0);

        document.querySelectorAll('.dash-hero-status-item').forEach(function (statusItem) {
            var label = statusItem.querySelector('.dash-hero-status-label');
            var value = statusItem.querySelector('.dash-hero-status-value');
            if (!label || !value) return;

            var key = (label.textContent || '').trim().toLowerCase();
            if (key === 'overdue') {
                adjustCountValue(value, deltas.overdue || 0);
                return;
            }

            if (key === 'today') {
                adjustCountValue(value, deltas.today || 0);
                return;
            }

            if (key === 'done last 7 days') {
                adjustCountValue(value, deltas.completedLast7Days || 0);
            }
        });
    }

    function adjustActionSectionCount(item, delta) {
        if (!item || !delta) return;

        var pendingSection = item.closest('.ai-section-group');
        if (pendingSection) {
            adjustCountValue(pendingSection.querySelector('.ai-section-count'), delta);
            return;
        }

        var completedSection = item.closest('.dash-section--actions');
        if (completedSection) {
            adjustCountValue(completedSection.querySelector('.dash-section-count'), delta);
        }
    }

    function startActionItemExit(item, direction) {
        if (!item) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            item.style.opacity = '0';
            item.style.pointerEvents = 'none';
            return;
        }

        var height = Math.max(item.offsetHeight, item.scrollHeight, 1);
        item.dataset.actionExitHeight = String(height);
        item.style.maxHeight = height + 'px';
        item.style.setProperty('--ai-leave-x', direction + 'px');
        item.offsetHeight;
        item.classList.add('ai-item--leaving');
    }

    function clearActionItemExit(item) {
        if (!item) return;

        item.classList.remove('ai-item--leaving');
        item.style.removeProperty('--ai-leave-x');
        item.style.removeProperty('max-height');
        item.style.removeProperty('opacity');
        item.style.removeProperty('pointer-events');
        delete item.dataset.actionExitHeight;
    }

    function revertActionItemExit(item) {
        if (!item) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            clearActionItemExit(item);
            return;
        }

        var height = parseInt(item.dataset.actionExitHeight || '0', 10);
        item.classList.remove('ai-item--leaving');
        item.style.maxHeight = (height > 0 ? height : Math.max(item.scrollHeight, 1)) + 'px';
        item.style.opacity = '1';
        item.style.pointerEvents = '';
        item.style.removeProperty('--ai-leave-x');

        window.setTimeout(function () {
            clearActionItemExit(item);
        }, 260);
    }

    function removeActionItemRow(item) {
        if (!item) return;

        var list = item.parentElement;
        var pendingSection = item.closest('.ai-section-group');
        var completedSection = item.closest('.dash-section--actions');

        item.remove();

        if (!list || list.querySelector('.ai-item')) return;

        if (pendingSection) {
            pendingSection.remove();
            return;
        }

        if (completedSection) {
            completedSection.remove();
        }
    }

    function buildActionMetricDeltas(item, nextIsCompleted) {
        var completedAt = parseActionCompletedAt(item);
        var completedWithinLastSevenDays = completedAt
            ? ((Date.now() - completedAt.getTime()) <= (7 * 24 * 60 * 60 * 1000))
            : false;

        return {
            pending: nextIsCompleted ? -1 : 1,
            overdue: parseActionBool(item, 'data-action-is-overdue') ? (nextIsCompleted ? -1 : 1) : 0,
            today: parseActionBool(item, 'data-action-is-due-today') ? (nextIsCompleted ? -1 : 1) : 0,
            completedLast7Days: nextIsCompleted ? 1 : (completedWithinLastSevenDays ? -1 : 0)
        };
    }

    function setActionCompletionState(id, isCompleted) {
        return fetch('/dashboard/actions/toggle', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ id: id, isCompleted: isCompleted })
        })
        .then(function (res) {
            if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (data) {
                    throw new Error(data.error || '');
                });
            }

            return res.json();
        });
    }

    // ── Toggle action item completion (with undo) ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-ai-toggle');
        if (!btn) return;

        var item = btn.closest('.ai-item');
        if (!item) return;
        var id = item.getAttribute('data-action-id');
        if (!id) return;
        if (item.getAttribute('data-action-busy') === 'true') return;

        var nextIsCompleted = !parseActionBool(item, 'data-action-is-completed');
        var metricDeltas = buildActionMetricDeltas(item, nextIsCompleted);
        btn.disabled = true;
        item.setAttribute('data-action-busy', 'true');
        item.classList.toggle('ai-item--completing', nextIsCompleted);
        adjustActionHeroMetrics(metricDeltas);
        adjustActionSectionCount(item, -1);
        startActionItemExit(item, nextIsCompleted ? 18 : -18);

        var title = (item.getAttribute('data-action-title') || '').trim();
        var shortTitle = title.length > 40 ? title.substring(0, 40) + '...' : title;

        setActionCompletionState(id, nextIsCompleted)
            .then(function (data) {
                item.setAttribute('data-action-is-completed', data.isCompleted ? 'true' : 'false');
                if (data.completedAt) {
                    item.setAttribute('data-action-completed-at', data.completedAt);
                } else {
                    item.removeAttribute('data-action-completed-at');
                }

                removeActionItemRow(item);
                debouncedReloadActionsTab({ quiet: true });
                trackEvent('action_completed', { completed: data.isCompleted });

                if (!nextIsCompleted) {
                    toast.success((shortTitle ? '\u201c' + shortTitle + '\u201d ' : 'Action ') + 'back on your list');
                    return;
                }

                toast.success((shortTitle ? '\u201c' + shortTitle + '\u201d ' : 'Action ') + 'done', {
                    undo: function () {
                        cancelReloadActionsTab();
                        setActionCompletionState(id, false)
                            .then(function () {
                                debouncedReloadActionsTab({ quiet: true });
                                trackEvent('action_completed', { completed: false });
                            })
                            .catch(function () {
                                toast.error("Couldn't undo action. Please try again.");
                                debouncedReloadActionsTab({ quiet: true });
                            });
                    }
                });
            })
            .catch(function (err) {
                item.removeAttribute('data-action-busy');
                btn.disabled = false;
                item.classList.remove('ai-item--completing');
                adjustActionSectionCount(item, 1);
                adjustActionHeroMetrics({
                    pending: -(metricDeltas.pending || 0),
                    overdue: -(metricDeltas.overdue || 0),
                    today: -(metricDeltas.today || 0),
                    completedLast7Days: -(metricDeltas.completedLast7Days || 0)
                });
                revertActionItemExit(item);
                toast.error(err.message || (nextIsCompleted ? "Couldn't complete action. Please try again." : "Couldn't move action back. Please try again."));
            });
    });

    // ── Delete action item (with undo) ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-ai-delete');
        if (!btn) return;

        var item = btn.closest('.ai-item');
        if (!item) return;
        var id = item.getAttribute('data-action-id');
        if (!id) return;

        // Cancel any existing pending undo for this item
        if (pendingUndos[id]) {
            clearTimeout(pendingUndos[id]);
            delete pendingUndos[id];
        }

        btn.disabled = true;
        slideOutItem(item, 40);

        var heroCounter = document.querySelector('.dash-hero-counter-num');
        var previousCount = heroCounter ? parseInt(heroCounter.textContent, 10) : NaN;
        if (heroCounter && !isNaN(previousCount) && previousCount > 0) {
            heroCounter.textContent = String(previousCount - 1);
        }

        pendingUndoActions[id] = { url: '/dashboard/actions/delete', body: JSON.stringify({ id: id }) };
        pendingUndos[id] = setTimeout(function () {
            delete pendingUndos[id];
            delete pendingUndoActions[id];
            fetch('/dashboard/actions/delete', {
                method: 'POST',
                headers: csrfHeaders(),
                body: JSON.stringify({ id: id })
            })
            .then(function (res) {
                if (!res.ok) throw new Error();
                debouncedReloadActionsTab({ quiet: true });
                trackEvent('action_deleted', {});
            })
            .catch(function () {
                btn.disabled = false;
                revertSlideOut(item);
                if (heroCounter && !isNaN(previousCount)) {
                    heroCounter.textContent = String(previousCount);
                }
                toast.error("Couldn't remove action. Please try again.");
            });
        }, 5000);

        toast.success('Action removed', {
            undo: function () {
                if (pendingUndos[id]) {
                    clearTimeout(pendingUndos[id]);
                    delete pendingUndos[id];
                }
                delete pendingUndoActions[id];
                btn.disabled = false;
                revertSlideOut(item);
                if (heroCounter && !isNaN(previousCount)) {
                    heroCounter.textContent = String(previousCount);
                }
            }
        });
    });

    // ── Snooze action item ──
    // Toggle snooze menu visibility when the clock button is clicked.
    document.addEventListener('click', function (e) {
        var toggleBtn = e.target.closest('.js-ai-snooze-toggle');
        if (!toggleBtn) {
            // Close any open snooze and reschedule menus when clicking elsewhere.
            document.querySelectorAll('.ai-snooze-menu:not([hidden]), .ai-reschedule-menu:not([hidden])').forEach(function (m) {
                m.hidden = true;
            });
            return;
        }

        var item = toggleBtn.closest('.ai-item');
        if (!item) return;
        var menu = item.querySelector('.ai-snooze-menu');
        if (!menu) return;

        e.stopPropagation();

        // Close all other open menus first.
        document.querySelectorAll('.ai-snooze-menu:not([hidden])').forEach(function (m) {
            if (m !== menu) m.hidden = true;
        });

        menu.hidden = !menu.hidden;
    });

    // Handle snooze option selection.
    function computeSnoozeUntil(btn) {
        var target = btn.getAttribute('data-snooze-target');
        if (target === 'latertoday') {
            var now = new Date();
            var hour = now.getHours();
            var label = 'later today';
            if (hour < 17) {
                now.setHours(17, 0, 0, 0);
            } else if (hour < 21) {
                now.setHours(21, 0, 0, 0);
                label = 'this evening';
            } else {
                now.setDate(now.getDate() + 1);
                now.setHours(8, 0, 0, 0);
                label = 'tomorrow morning';
            }
            return { iso: now.toISOString(), label: label };
        }
        if (target === 'nextmonday') {
            var d = new Date();
            var day = d.getDay(); // 0=Sun
            var daysUntilMon = day === 0 ? 1 : (8 - day);
            d.setDate(d.getDate() + daysUntilMon);
            d.setHours(8, 0, 0, 0);
            return { iso: d.toISOString(), label: 'next Monday' };
        }
        var hours = parseInt(btn.getAttribute('data-snooze-hours') || '24', 10);
        var label = hours === 1 ? '1 hour' : hours === 4 ? '4 hours' : hours === 24 ? 'tomorrow' : '1 week';
        return { iso: new Date(Date.now() + hours * 60 * 60 * 1000).toISOString(), label: label };
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-ai-snooze');
        if (!btn) return;

        var item = btn.closest('.ai-item');
        if (!item) return;
        var id = item.getAttribute('data-action-id');
        if (!id) return;

        var snooze = computeSnoozeUntil(btn);

        var menu = item.querySelector('.ai-snooze-menu');
        if (menu) menu.hidden = true;

        btn.disabled = true;

        fetch('/dashboard/actions/snooze', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ id: id, snoozeUntil: snooze.iso })
        })
        .then(function (res) {
            if (!res.ok) throw new Error();
            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduced) {
                debouncedReloadActionsTab({ quiet: true });
            } else {
                item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                item.style.opacity = '0';
                item.style.transform = 'translateX(-20px)';
                var snoozeFallback = setTimeout(function () {
                    debouncedReloadActionsTab({ quiet: true });
                }, 600);
                item.addEventListener('transitionend', function () {
                    clearTimeout(snoozeFallback);
                    debouncedReloadActionsTab({ quiet: true });
                }, { once: true });
            }

            toast.success('Snoozed until ' + snooze.label);
            trackEvent('action_snoozed', { label: snooze.label });
        })
        .catch(function () {
            btn.disabled = false;
            toast.error("Couldn't snooze action. Please try again.");
        });
    });

    // ── Inline quick-reschedule ──
    // Toggle reschedule menu when clicking due date pill.
    document.addEventListener('click', function (e) {
        var pill = e.target.closest('.js-ai-reschedule-trigger');
        if (!pill) return;

        var item = pill.closest('.ai-item');
        if (!item) return;
        var menu = item.querySelector('.ai-reschedule-menu');
        if (!menu) return;

        e.stopPropagation();
        e.preventDefault();

        // Close all other open menus first (snooze + reschedule).
        document.querySelectorAll('.ai-snooze-menu:not([hidden]), .ai-reschedule-menu:not([hidden])').forEach(function (m) {
            if (m !== menu) m.hidden = true;
        });

        menu.hidden = !menu.hidden;
    });

    // Handle reschedule option selection.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-ai-reschedule');
        if (!btn) return;

        var item = btn.closest('.ai-item');
        if (!item) return;
        var id = item.getAttribute('data-action-id');
        if (!id) return;

        var action = btn.getAttribute('data-date-action');
        var nextDate = new Date();
        if (action === 'tomorrow') {
            nextDate.setDate(nextDate.getDate() + 1);
        } else if (action === 'nextweek') {
            nextDate.setDate(nextDate.getDate() + 7);
        }
        var dueDate = toDateInputValue(nextDate);

        var menu = item.querySelector('.ai-reschedule-menu');
        if (menu) menu.hidden = true;

        btn.disabled = true;

        fetch('/dashboard/actions/update', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({
                id: id,
                title: item.getAttribute('data-action-title') || '',
                dueDate: dueDate,
                reminderPolicy: item.getAttribute('data-action-reminder') || null,
                bucket: null
            })
        })
        .then(function (res) {
            if (!res.ok) throw new Error();
            return res.json();
        })
        .then(function () {
            debouncedReloadActionsTab({ quiet: true });
            var label = action === 'today' ? 'today' : action === 'tomorrow' ? 'tomorrow' : 'next week';
            toast.success('Rescheduled to ' + label);
            trackEvent('action_rescheduled', { target: action });
        })
        .catch(function () {
            btn.disabled = false;
            toast.error("Couldn't reschedule action. Please try again.");
        });
    });

    // ── Smooth collapse for Later <details> section (delegated — works after reloads) ──
    document.addEventListener('click', function (e) {
        var summary = e.target.closest('.ai-section-divider--collapsible');
        if (!summary) return;

        var details = summary.closest('details');
        if (!details) return;

        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return; // let native behavior handle it

        e.preventDefault();

        var list = details.querySelector('.ai-list');
        if (!list) {
            details.open = !details.open;
            return;
        }

        if (details.open) {
            // Animate out, then mark closed
            var closeH = list.scrollHeight;
            list.style.maxHeight = closeH + 'px';
            list.style.overflow = 'hidden';
            list.offsetHeight; // force reflow
            list.style.transition = 'max-height 0.3s ease, opacity 0.2s ease';
            list.style.maxHeight = '0';
            list.style.opacity = '0';
            list.addEventListener('transitionend', function handler(ev) {
                if (ev.propertyName !== 'max-height') return;
                list.removeEventListener('transitionend', handler);
                details.open = false;
                list.style.cssText = '';
            }, { once: false });
        } else {
            details.open = true;
            var openH = list.scrollHeight;
            list.style.maxHeight = '0';
            list.style.overflow = 'hidden';
            list.style.opacity = '0';
            list.offsetHeight;
            list.style.transition = 'max-height 0.3s ease, opacity 0.2s ease';
            list.style.maxHeight = openH + 'px';
            list.style.opacity = '1';
            list.addEventListener('transitionend', function handler(ev) {
                if (ev.propertyName !== 'max-height') return;
                list.removeEventListener('transitionend', handler);
                list.style.cssText = '';
            }, { once: false });
        }
    });

    // ── Intelligence panel (replaces old "Card info" debug view) ──
    function escHtml(s) {
        var d = document.createElement('div');
        d.textContent = s;
        return d.innerHTML;
    }

    // Extract person name from "email → Name", "email -> Name", "email is for Name", "email is about Name", "email is Name"
    var _tagSeparators = [' is for ', ' is about ', ' is '];
    function extractPersonName(tag) {
        var t = tag.trim();
        // Arrow formats first
        var ai = t.indexOf('\u2192');
        if (ai < 0) ai = t.indexOf('->');
        if (ai >= 0) return { name: t.substring(ai + (t.charAt(ai) === '\u2192' ? 1 : 2)).trim(), sender: t.substring(0, ai).trim() };
        // Natural language separators
        for (var i = 0; i < _tagSeparators.length; i++) {
            var si = t.toLowerCase().indexOf(_tagSeparators[i]);
            if (si >= 0) return { name: t.substring(si + _tagSeparators[i].length).replace(/\.\s*$/, '').trim(), sender: t.substring(0, si).trim() };
        }
        return { name: t, sender: '' };
    }

    function buildIntelPanel(btn) {
        var type = escHtml(btn.getAttribute('data-info-type') || '');
        var imp = escHtml(btn.getAttribute('data-info-importance') || '');
        var senderEmail = btn.getAttribute('data-info-sender') || '';
        var sender = escHtml(senderEmail);
        var tags = btn.getAttribute('data-info-tags') || '';
        var focus = btn.getAttribute('data-info-focus') === 'True';
        var ignore = btn.getAttribute('data-info-ignore') === 'True';
        var correlation = btn.getAttribute('data-info-correlation') === 'True';
        var learned = btn.getAttribute('data-info-learned') === 'True';
        var household = btn.getAttribute('data-info-household') === 'True';

        var rows = [];

        // People & context rule
        if (correlation) {
            var tagDisplay = '';
            var senderHint = '';
            if (tags) {
                var parsed = tags.split(',').map(function (t) { return extractPersonName(t); });
                var names = parsed.map(function (p) { return p.name; }).filter(Boolean);
                var senders = parsed.map(function (p) { return p.sender; }).filter(Boolean);
                tagDisplay = escHtml(names.join(' & '));
                if (senders.length > 0) {
                    senderHint = 'Recognized ' + escHtml(senders[0]) + ' from your People &amp; context rules';
                }
            }
            rows.push(
                '<div class="dc-intel-row dc-intel-row--people">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' +
                '<div><strong>About ' + (tagDisplay || 'People &amp; context') + '</strong><span>' + (senderHint || 'Matched your People &amp; context rules') + '</span></div>' +
                '</div>'
            );
        }

        // Focus rule
        if (focus) {
            rows.push(
                '<div class="dc-intel-row dc-intel-row--focus">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>' +
                '<div><strong>Priority rule matched</strong><span>Boosted by your focus rules</span></div>' +
                '</div>'
            );
        }

        // Ignore rule
        if (ignore) {
            rows.push(
                '<div class="dc-intel-row dc-intel-row--ignore">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>' +
                '<div><strong>Quiet list matched</strong><span>De-emphasized by your quiet rules</span></div>' +
                '</div>'
            );
        }

        // Learned pattern
        if (learned) {
            rows.push(
                '<div class="dc-intel-row dc-intel-row--learned">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>' +
                '<div><strong>Learned pattern</strong><span>Based on how you handle similar emails</span></div>' +
                '</div>'
            );
        }

        // If no rules but panel was opened via overflow, show classification
        if (rows.length === 0) {
            rows.push(
                '<div class="dc-intel-row dc-intel-row--none">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
                '<div><strong>No custom rules applied</strong><span>Classified using default intelligence</span></div>' +
                '</div>'
            );
        }

        // Metadata footer
        var meta = [];
        if (type) meta.push(type.charAt(0).toUpperCase() + type.slice(1));
        if (imp) meta.push(imp + ' importance');
        if (household) meta.push('Household-relevant');

        var panel = document.createElement('div');
        panel.className = 'dc-intel-panel';
        panel.innerHTML =
            '<div class="dc-intel-header">' +
            '<span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.09 6.26L20.18 9l-5.09 3.74L17.18 19 12 15.27 6.82 19l2.09-6.26L3.82 9l6.09-.74z"/></svg> Intelligence</span>' +
            '<button type="button" class="dc-intel-close" aria-label="Close">&times;</button>' +
            '</div>' +
            '<div class="dc-intel-body">' + rows.join('') + '</div>' +
            (meta.length > 0 ? '<div class="dc-intel-meta">' + meta.join(' &middot; ') + '</div>' : '') +
            '<div class="dc-intel-quick-actions">' +
                (senderEmail ? '<button type="button" class="dc-intel-quick-btn js-dc-intel-quick" data-action="prioritize" data-sender="' + escapeAttr(senderEmail) + '">Always prioritize this sender</button>' : '') +
                (senderEmail ? '<button type="button" class="dc-intel-quick-btn dc-intel-quick-btn--quiet js-dc-intel-quick" data-action="deprioritize" data-sender="' + escapeAttr(senderEmail) + '">Quiet this sender</button>' : '') +
            '</div>' +
            '<a href="/intelligence" class="dc-intel-link">Manage rules</a>';

        panel.querySelector('.dc-intel-close').addEventListener('click', function () { panel.remove(); }, { once: true });
        return panel;
    }

    function insertIntelPanel(btn, card) {
        var existing = card.querySelector('.dc-intel-panel');
        if (existing) {
            existing.remove();
            btn.setAttribute('aria-expanded', 'false');
            return;
        }

        var panel = buildIntelPanel(btn);
        panel.addEventListener('remove-panel', function () {
            btn.setAttribute('aria-expanded', 'false');
        });
        // Patch close button to also reset aria-expanded
        var closeBtn = panel.querySelector('.dc-intel-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                btn.setAttribute('aria-expanded', 'false');
            });
        }

        var mobileBody = card.querySelector('.dc-mobile-body');
        var compactCollapsed = card.classList.contains('dc--compact') && !card.classList.contains('dc--expanded');
        if (mobileBody && !compactCollapsed) {
            mobileBody.appendChild(panel);
        } else {
            card.appendChild(panel);
        }

        btn.setAttribute('aria-expanded', 'true');
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Overflow menu "Intelligence" button
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-card-info');
        if (!btn) return;

        // Close the overflow menu
        var menu = btn.closest('.dc-overflow-menu');
        if (menu) { menu.hidden = true; }
        var overflowBtn = btn.closest('.dc-overflow-wrap')?.querySelector('.dc-overflow-btn');
        if (overflowBtn) overflowBtn.setAttribute('aria-expanded', 'false');

        var card = btn.closest('.dc');
        if (!card) return;

        insertIntelPanel(btn, card);
    });

    // Inline intelligence indicator button
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-intel-toggle');
        if (!btn) return;

        var card = btn.closest('.dc');
        if (!card) return;

        insertIntelPanel(btn, card);
    });

    // ── Quick-action: create rule from digest card ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-intel-quick');
        if (!btn) return;

        var action = btn.getAttribute('data-action');
        var sender = btn.getAttribute('data-sender');
        if (!action || !sender) return;

        btn.disabled = true;
        btn.textContent = 'Saving...';

        fetch('/api/intelligence/rules', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({ senderEmail: sender, action: action })
        })
        .then(function (res) {
            if (!res.ok) throw new Error();
            return res.json();
        })
        .then(function () {
            btn.textContent = 'Done';
            btn.classList.add('dc-intel-quick-btn--done');
            toast.success('Rule created — your ' + getDashboardBriefNoun() + ' will adapt');
            trackEvent('quick_rule_created', { action: action });
            // Disable the other quick-action button on the same panel
            var panel = btn.closest('.dc-intel-panel');
            if (panel) {
                panel.querySelectorAll('.js-dc-intel-quick').forEach(function (b) { b.disabled = true; });
            }
        })
        .catch(function () {
            btn.disabled = false;
            btn.textContent = action === 'prioritize' ? 'Always prioritize this sender' : 'Quiet this sender';
            toast.error("Couldn't create rule. Please try again.");
        });
    });

    // ── Dismiss "Add a person" context suggestion ──
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-context-suggest-close');
        if (!btn) return;
        var suggest = btn.closest('.js-dc-context-suggest');
        if (!suggest) return;
        var sender = suggest.getAttribute('data-sender');
        if (sender) {
            try { sessionStorage.setItem('ctx-dismiss-' + sender, '1'); } catch (_) {}
        }
        suggest.remove();
    });

    // Hide previously dismissed suggestions on load
    document.querySelectorAll('.js-dc-context-suggest').forEach(function (el) {
        var sender = el.getAttribute('data-sender');
        try {
            if (sender && sessionStorage.getItem('ctx-dismiss-' + sender) === '1') {
                el.remove();
            }
        } catch (_) {}
    });

    // ── Inline "who is this about?" wizard (opened from the context-suggest chip) ──

    // Shared by the wizard's Save and the chip's one-tap confirm. Resolves with the server's
    // response data; rejects with an Error whose message is safe to show the user.
    function postCorrelationRule(senderEmailRaw, personLabel) {
        return fetch('/api/intelligence/correlation-rules', {
            method: 'POST',
            headers: Object.assign({ 'Content-Type': 'application/json' }, csrfHeaders()),
            body: JSON.stringify({ senderEmail: senderEmailRaw.toLowerCase(), personLabel: personLabel })
        }).then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (data) {
                if (!res.ok) throw new Error(data.error || "Couldn't save. Please try again.");
                return data;
            });
        });
    }

    function buildPersonChipRow(headingText, values) {
        return '<div class="dc-person-panel-suggestions">' +
            '<span class="dc-person-panel-suggest-heading">' + escHtml(headingText) + '</span>' +
            values.map(function (s) {
                return '<button type="button" class="dc-person-panel-chip" data-value="' + escapeAttr(s) + '">' + escHtml(s) + '</button>';
            }).join('') +
            '</div>';
    }

    function bindPersonChips(scope, input) {
        scope.querySelectorAll('.dc-person-panel-chip').forEach(function (chip) {
            if (chip.dataset.bound === 'true') return;
            chip.dataset.bound = 'true';
            chip.addEventListener('click', function () {
                input.value = chip.getAttribute('data-value') || '';
                input.dataset.source = 'chip';
                input.focus();
            });
        });
    }

    function buildPersonPanel(btn) {
        var senderName = btn.getAttribute('data-sender-name') || '';
        var placeholder = btn.getAttribute('data-placeholder') || 'e.g. a person or project';
        var senderEmailRaw = btn.closest('.js-dc-context-suggest')?.getAttribute('data-sender') || '';

        // First suggestion group: who the AI says THIS email is about (KeyEntities.People,
        // pre-filtered server-side and passed via data-people as JSON). AI-derived text, so every
        // value is routed through escHtml/escapeAttr before it ever touches innerHTML.
        var cardGuesses = [];
        try {
            var parsed = JSON.parse(btn.getAttribute('data-people') || '[]');
            if (Array.isArray(parsed)) {
                cardGuesses = parsed.filter(function (p) { return typeof p === 'string' && p.trim(); }).slice(0, 3);
            }
        } catch (_) { /* malformed attribute — suggestions are an enhancement, not a requirement */ }

        var panel = document.createElement('div');
        panel.className = 'dc-person-panel';
        panel.dataset.senderEmail = senderEmailRaw;
        panel.innerHTML =
            '<div class="dc-person-panel-header">' +
            '<span>Who is this about?</span>' +
            '<button type="button" class="dc-person-panel-close" aria-label="Close">&times;</button>' +
            '</div>' +
            '<p class="dc-person-panel-intro">Emails from ' + escHtml(senderName) + ' are about&hellip;</p>' +
            '<input type="text" class="dc-person-panel-input" maxlength="80" placeholder="' + escapeAttr(placeholder) + '" aria-label="Who ' + escapeAttr(senderName) + '’s emails are about" />' +
            (cardGuesses.length > 0 ? buildPersonChipRow('From this email', cardGuesses) : '') +
            '<div class="dc-person-panel-known" hidden></div>' +
            '<p class="dc-person-panel-error" role="alert" hidden></p>' +
            '<div class="dc-person-panel-actions">' +
            '<button type="button" class="dc-person-panel-cancel">Cancel</button>' +
            '<button type="button" class="dc-person-panel-save">Save</button>' +
            '</div>' +
            '<a href="/intelligence" class="dc-person-panel-manage">Manage all rules</a>';

        var input = panel.querySelector('.dc-person-panel-input');
        input.dataset.source = 'typed';
        input.addEventListener('input', function () { input.dataset.source = 'typed'; });
        bindPersonChips(panel, input);

        // Second group, loaded async: people the user has ALREADY named in their rules. After the
        // first child/project, every later wizard open should be one tap on a familiar name.
        var lowerGuesses = cardGuesses.map(function (g) { return g.toLowerCase(); });
        fetch('/api/intelligence/correlation-rules', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.ok ? res.json() : null; })
            .then(function (data) {
                if (!data || !Array.isArray(data.people) || !panel.isConnected) return;
                var known = data.people.filter(function (p) {
                    return typeof p === 'string' && p.trim() && lowerGuesses.indexOf(p.toLowerCase()) < 0;
                }).slice(0, 8);
                if (known.length === 0) return;
                var wrap = panel.querySelector('.dc-person-panel-known');
                wrap.innerHTML = buildPersonChipRow('Your people', known);
                wrap.hidden = false;
                bindPersonChips(wrap, input);
            })
            .catch(function (_) { /* suggestions only — the free-text input is always enough */ });

        return panel;
    }

    function replacePersonSuggestWithConfirmation(suggestEl, senderName, personLabel) {
        suggestEl.innerHTML =
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
            '<span>Future emails from ' + escHtml(senderName) + ' will be linked to ' + escHtml(personLabel) + '.</span>';
        suggestEl.classList.add('dc-context-suggest--confirmed');
    }

    // After a save, the control the user was on (Save button or the one-tap link) is destroyed
    // with the chip's old content — without this, keyboard focus silently falls to <body> and a
    // keyboard user is dumped back at the top of the page.
    function focusPersonConfirmation(suggestEl) {
        if (!suggestEl || !suggestEl.isConnected) return;
        suggestEl.setAttribute('tabindex', '-1');
        suggestEl.focus({ preventScroll: true });
    }

    // A rule for this sender can apply to more than one card in the current feed — clear the
    // chip (and its dismiss key) everywhere, not just on the card the wizard was opened from.
    function removePersonChipsForSender(senderEmailRaw, personLabel) {
        var normalized = senderEmailRaw.toLowerCase();
        document.querySelectorAll('.js-dc-context-suggest').forEach(function (el) {
            var elSenderRaw = el.getAttribute('data-sender') || '';
            if (elSenderRaw.toLowerCase() !== normalized) return;

            var openBtn = el.querySelector('.js-dc-person-open');
            var senderName = openBtn ? (openBtn.getAttribute('data-sender-name') || elSenderRaw) : elSenderRaw;
            replacePersonSuggestWithConfirmation(el, senderName, personLabel);

            try { sessionStorage.setItem('ctx-dismiss-' + elSenderRaw, '1'); } catch (_) {}
        });
    }

    function savePersonRule(panel) {
        var input = panel.querySelector('.dc-person-panel-input');
        var errorEl = panel.querySelector('.dc-person-panel-error');
        var personLabel = (input.value || '').trim();
        if (!personLabel) {
            errorEl.textContent = 'Enter a name or label first.';
            errorEl.hidden = false;
            input.focus();
            return;
        }

        var senderEmailRaw = panel.dataset.senderEmail || '';
        if (!senderEmailRaw) return;

        var suggestEl = panel.closest('.js-dc-context-suggest');
        var saveBtn = panel.querySelector('.dc-person-panel-save');
        saveBtn.disabled = true;
        saveBtn.classList.add('is-loading');
        errorEl.hidden = true;

        var source = input.dataset.source === 'chip' ? 'panel_chip' : 'panel_typed';
        postCorrelationRule(senderEmailRaw, personLabel)
            .then(function (data) {
                toast.success('Rule saved.');
                trackEvent('correlation_rule_created', { source: source });
                // Confirm with the label the server actually stored — it collapses whitespace and
                // truncates at 80 chars, so echoing the raw input could promise something else.
                removePersonChipsForSender(senderEmailRaw, (data && data.personLabel) || personLabel);
                focusPersonConfirmation(suggestEl);
            })
            .catch(function (err) {
                saveBtn.disabled = false;
                saveBtn.classList.remove('is-loading');
                errorEl.textContent = (err && err.message) || "Couldn't save. Please try again.";
                errorEl.hidden = false;
            });
    }

    function insertPersonPanel(btn) {
        var suggest = btn.closest('.js-dc-context-suggest');
        if (!suggest) return;

        var existing = suggest.querySelector('.dc-person-panel');
        if (existing) {
            existing.remove();
            return;
        }

        // Only one wizard open at a time across the feed.
        document.querySelectorAll('.dc-person-panel').forEach(function (p) { p.remove(); });

        var panel = buildPersonPanel(btn);
        suggest.appendChild(panel);

        // Dismissal returns focus to the link that opened the panel — otherwise keyboard
        // focus falls to <body> and the user restarts from the top of the page.
        function closePanel() {
            panel.remove();
            if (btn.isConnected) btn.focus();
        }

        var input = panel.querySelector('.dc-person-panel-input');
        panel.querySelector('.dc-person-panel-close').addEventListener('click', closePanel);
        panel.querySelector('.dc-person-panel-cancel').addEventListener('click', closePanel);
        panel.querySelector('.dc-person-panel-save').addEventListener('click', function () { savePersonRule(panel); });
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                savePersonRule(panel);
            }
        });
        // Escape works from ANY control in the panel (chips, Cancel, Save, the manage link) —
        // previously only the text input listened, so Escape from a suggestion chip did nothing.
        panel.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                closePanel();
            }
        });

        input.focus();
        panel.scrollIntoView({
            // Smooth scrolling is motion — honor the OS-level preference.
            behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest'
        });
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-person-open');
        if (!btn) return;
        insertPersonPanel(btn);
    });

    // One-tap confirm on the chip itself ("Is this about Penny? Yes, link them") — the AI's
    // single-person guess for this email, saved without opening the panel at all.
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-person-confirm');
        if (!btn || btn.disabled) return;

        var personLabel = (btn.getAttribute('data-person') || '').trim();
        var senderEmailRaw = btn.closest('.js-dc-context-suggest')?.getAttribute('data-sender') || '';
        if (!personLabel || !senderEmailRaw) return;

        btn.disabled = true;
        btn.classList.add('is-loading');

        var suggestEl = btn.closest('.js-dc-context-suggest');
        postCorrelationRule(senderEmailRaw, personLabel)
            .then(function (data) {
                toast.success('Rule saved.');
                trackEvent('correlation_rule_created', { source: 'one_tap' });
                removePersonChipsForSender(senderEmailRaw, (data && data.personLabel) || personLabel);
                focusPersonConfirmation(suggestEl);
            })
            .catch(function (err) {
                btn.disabled = false;
                btn.classList.remove('is-loading');
                toast.error((err && err.message) || "Couldn't save. Please try again.");
            });
    });

    // ── Track action item from digest card ──

    // Only these shapes become a real DueAt server-side (ActionItemService.TryResolveDueAt).
    // Everything else is stored as free text with DueAt = null, and a reminder policy attached
    // to a null DueAt can never fire.
    //
    // Date.parse is deliberately NOT the test: V8 ignores unrecognised alphabetic tokens, so
    // Date.parse("ASAP, 2026") succeeds and yields Jan 1 — which would promise a reminder for
    // exactly the fuzzy AI due-text this gate exists to reject.
    // Verified against the server's own preprocessing (see TryResolveDueAt): "Mar 27", "March 27",
    // "Apr 3", "Mar 30-Apr 3" and "3/27" all resolve; "Apr 2, 6pm" does NOT — appending the year
    // after a time suffix makes it unparseable there, so we must not promise a reminder for it.
    // Month + day, optionally followed by a 4-digit year — but nothing else. A trailing time
    // ("Apr 2, 6pm") must NOT match: the server appends the year after it, and "Apr 2, 6pm 2026"
    // fails to parse there, so treating it as concrete would promise an unsendable reminder.
    var MONTH_DAY_RE = /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+\d{1,2}(?:\s*,?\s*\d{4})?\s*$/i;
    var NUMERIC_MD_RE = /^(\d{1,2})\/(\d{1,2})(?:\/(\d{4}))?$/;

    function localNoon(year, monthIndex, day) {
        return new Date(year, monthIndex, day, 12, 0, 0, 0);
    }

    function parseDueDateLikeServer(raw) {
        var s = (raw || '').trim();
        if (!s) return null;

        var now = new Date();
        var lower = s.toLowerCase();

        // Exact matches only — the server compares the whole string, so "today at 5pm" does NOT
        // resolve there even though it reads like it should.
        if (lower === 'today' || lower === 'tonight') return localNoon(now.getFullYear(), now.getMonth(), now.getDate());
        if (lower === 'tomorrow') return localNoon(now.getFullYear(), now.getMonth(), now.getDate() + 1);

        var iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
        if (iso) return localNoon(+iso[1], +iso[2] - 1, +iso[3]);

        if (s.indexOf('T') !== -1 || /z$/i.test(s)) {
            var withTime = Date.parse(s);
            if (!isNaN(withTime)) return new Date(withTime);
        }

        // Natural formats ("Mar 27", "March 27", "Dec 25, 2027", "3/27", "Mar 30-Apr 3" → Mar 30).
        // The range/list stripping runs only AFTER the ISO checks above — doing it first would
        // split "2026-08-15" at its own dash and parse the year alone.
        var firstSegment = s.split('-')[0].split(';')[0].trim();

        // Numeric M/D or M/D/YYYY — built directly rather than via Date.parse so the invariant
        // month-first reading matches the server's, and an out-of-range value fails here the same
        // way it fails there instead of silently rolling over into another month.
        var numeric = NUMERIC_MD_RE.exec(firstSegment);
        if (numeric) {
            var month = +numeric[1];
            var day = +numeric[2];
            if (month < 1 || month > 12 || day < 1 || day > 31) return null;
            return localNoon(numeric[3] ? +numeric[3] : now.getFullYear(), month - 1, day);
        }

        if (!MONTH_DAY_RE.test(firstSegment)) return null;

        var withYear = /\d{4}/.test(firstSegment) ? firstSegment : firstSegment + ' ' + now.getFullYear();
        var natural = Date.parse(withYear);
        return isNaN(natural) ? null : new Date(natural);
    }

    // Calendar-day difference, not elapsed hours — "today" resolved to local noon is +3h at 9am,
    // which an hours-based comparison would file under ThisWeek instead of Today.
    function calendarDaysUntil(target) {
        var t = new Date(target.getFullYear(), target.getMonth(), target.getDate());
        var n = new Date();
        return Math.round((t - new Date(n.getFullYear(), n.getMonth(), n.getDate())) / 86400000);
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-dc-track-action');
        if (!btn || btn.classList.contains('is-tracked')) return;

        var title = btn.getAttribute('data-title') || '';
        var dueDate = btn.getAttribute('data-due') || null;
        var reminderPolicy = btn.getAttribute('data-reminder') || null;
        var sourceId = btn.getAttribute('data-source-id') || null;
        var sourceSubject = btn.getAttribute('data-source-subject') || null;
        var sourceSender = btn.getAttribute('data-source-sender') || null;

        if (!title.trim()) return;

        // resolvedDue is non-null only for due text the SERVER can also turn into a real DueAt.
        var resolvedDue = parseDueDateLikeServer(dueDate);
        var bucket = null;

        if (resolvedDue) {
            var diffDays = calendarDaysUntil(resolvedDue);
            bucket = diffDays <= 0 ? 'Today' : (diffDays <= 7 ? 'ThisWeek' : 'Later');
        } else if (dueDate && dueDate.trim()) {
            // Fuzzy text the server will store verbatim with DueAt = null. It still deserves a
            // sensible bucket (the server keeps the client's bucket when it can't resolve a date),
            // so keep the loose substring match here — just never promise a reminder off it.
            var lower = dueDate.trim().toLowerCase();
            if (lower.indexOf('today') !== -1 || lower.indexOf('tonight') !== -1) {
                bucket = 'Today';
            } else if (lower.indexOf('tomorrow') !== -1 || lower.indexOf('this week') !== -1) {
                bucket = 'ThisWeek';
            }
        }

        if (!bucket) {
            bucket = 'Later';
        }

        // The server emits data-reminder whenever ANY due text is present — a cheap presence
        // check, not a real parse. Forward the policy only when the due text resolves to a date
        // the server will also resolve; otherwise it persists as ReminderPolicy=SameDayMorning
        // with DueAt=null, which ShouldIncludeInReminder skips forever — a reminder the UI
        // promised and the backend can never send.
        if (!resolvedDue) {
            reminderPolicy = null;
        }

        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch('/dashboard/actions', {
            method: 'POST',
            headers: csrfHeaders(),
            body: JSON.stringify({
                title: title,
                dueDate: dueDate,
                reminderPolicy: reminderPolicy,
                sourceEmailMessageId: sourceId,
                sourceEmailSubject: sourceSubject,
                sourceEmailSender: sourceSender,
                bucket: bucket,
                source: 'ai_extracted'
            })
        })
        .then(function (res) {
            if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (data) {
                    throw new Error(data.error || '');
                });
            }
            return res.json();
        })
        .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-tracked');
            btn.disabled = false;
            if (getDashboardActiveView() === 'actions') {
                reloadActionsTab();
            } else {
                bumpDashboardActionCount();
            }
            toast.success('Action tracked to ' + (bucket === 'Today' ? 'Today' : bucket === 'ThisWeek' ? 'This week' : 'Later'));
            trackEvent('action_created', { source: 'digest_card' });
            var card = btn.closest('.dc');
            recordIntelligenceSignal('ActionTracked', card);
        })
        .catch(function (err) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            toast.error(err.message || "Couldn't track action. Please try again.");
        });
    });

}

var reloadActionsDebounceTimer = null;
var reloadActionsDebounceQuiet = false;

function cancelReloadActionsTab() {
    clearTimeout(reloadActionsDebounceTimer);
    reloadActionsDebounceTimer = null;
    reloadActionsDebounceQuiet = false;
}

function debouncedReloadActionsTab(options) {
    reloadActionsDebounceQuiet = reloadActionsDebounceQuiet || Boolean(options && options.quiet);
    clearTimeout(reloadActionsDebounceTimer);
    reloadActionsDebounceTimer = setTimeout(function () {
        var quiet = reloadActionsDebounceQuiet;
        reloadActionsDebounceTimer = null;
        reloadActionsDebounceQuiet = false;
        reloadActionsTab({ quiet: quiet });
    }, 350);
}

function reloadActionsTab(options) {
    var target = document.getElementById('dash-feed-target');
    if (!target) return;

    var view = getDashboardActiveView();
    var query = getDashboardSearchQuery();
    var quiet = Boolean(options && options.quiet);

    syncDashboardSearchVisibility(view);
    syncDashboardSearchScope(view);
    target.setAttribute('aria-busy', 'true');
    if (!quiet) {
        beginDashboardFeedLoading(target);
    }

    fetch(buildDashboardFeedUrl(view, query), { credentials: 'same-origin' })
        .then(function (res) {
            if (!res.ok) throw new Error();
            return res.text();
        })
        .then(function (html) {
            replaceDashboardFeedFromHtml(target, html);
        })
        .catch(function () {
            if (quiet) {
                target.setAttribute('aria-busy', 'false');
            } else {
                endDashboardFeedLoading(target);
            }
            // Silent; the toast from the triggering action already communicated success
        });
}

// ── Intelligence: Dashboard inline insights ──

function initDashboardInsights() {
    var toggle = document.getElementById('dash-intel-toggle');
    var container = document.getElementById('dash-intel-insights');
    if (!toggle || !container) return;

    var loaded = false;

    toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
            container.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.textContent = 'Review';
            return;
        }

        container.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = 'Hide';

        if (!loaded) {
            loaded = true;
            var abortCtrl = new AbortController();
            var timeoutId = setTimeout(function () { abortCtrl.abort(); }, 12000);
            fetch('/api/intelligence/insights', { credentials: 'same-origin', signal: abortCtrl.signal })
                .then(function (res) { clearTimeout(timeoutId); return res.ok ? res.json() : { insights: [] }; })
                .then(function (data) { renderDashboardInsights(container, data.insights || []); })
                .catch(function () {
                    clearTimeout(timeoutId);
                    container.innerHTML = '<p class="dash-intel-insights-empty">Could not load patterns.</p>';
                    toast.error('Patterns took too long to load. Try again later.');
                });
        }
    });

    // Delegated handlers for accept/dismiss
    container.addEventListener('click', function (e) {
        var acceptBtn = e.target.closest('.js-dash-insight-accept');
        if (acceptBtn) {
            handleDashboardInsightAccept(acceptBtn, container);
            return;
        }
        var dismissBtn = e.target.closest('.js-dash-insight-dismiss');
        if (dismissBtn) {
            handleDashboardInsightDismiss(dismissBtn, container);
        }
    });
}

window.Stackora.initDashboardInsights = initDashboardInsights;

/** After #dash-feed-target (or chrome inside it) is replaced, run the same wiring as replaceDashboardFeedFromHtml. */
window.Stackora.applyDashboardFeedDomEnhancements = function (root) {
    var el = root || document.getElementById('dash-feed-target');
    if (!el) return;
    bindDashboardInteractiveRegions(el);
    initDashboardInsights();
    initFocusedDashboardState();
    applyDashboardTestEmailSessionLock();
    syncDashboardSearchUi(getDashboardSearchQuery(), { isLoading: false });
};

function renderDashboardInsights(container, insights) {
    if (insights.length === 0) {
        container.innerHTML = '<p class="dash-intel-insights-empty">No patterns to review right now.</p>';
        return;
    }

    var html = '';
    var shown = insights.slice(0, 5);
    shown.forEach(function (insight) {
        var actionLabel = insight.suggestedAction === 'prioritize' ? 'Prioritize' : insight.suggestedAction === 'mute' ? 'Mute' : 'Quiet';
        var colorClass = insight.actionColor === 'green' ? 'dash-intel-insight--green' : insight.actionColor === 'red' ? 'dash-intel-insight--red' : 'dash-intel-insight--amber';
        html += '<div class="dash-intel-insight ' + colorClass + '" data-insight-id="' + escapeAttr(insight.insightId) + '">' +
            '<div class="dash-intel-insight-body">' +
                '<div class="dash-intel-insight-title">' + escapeHtml(insight.title) + '</div>' +
                '<div class="dash-intel-insight-desc">' + escapeHtml(insight.description) +
                    ' <span class="dash-intel-insight-meta">' + insight.signalCount + ' signals · ' + insight.confidencePercent + '% confidence</span>' +
                '</div>' +
            '</div>' +
            '<div class="dash-intel-insight-actions">' +
                '<button type="button" class="dash-intel-insight-btn dash-intel-insight-btn--accept js-dash-insight-accept">' + escapeHtml(actionLabel) + '</button>' +
                '<button type="button" class="dash-intel-insight-btn dash-intel-insight-btn--dismiss js-dash-insight-dismiss">Dismiss</button>' +
            '</div>' +
        '</div>';
    });

    if (insights.length > 5) {
        html += '<a href="/intelligence" class="dash-intel-insights-more">See all ' + insights.length + ' patterns</a>';
    }
    html += '<a href="/intelligence#learned-behaviors-heading" class="dash-intel-insights-manage">Manage rules</a>';

    container.innerHTML = html;
}

function handleDashboardInsightAccept(btn, container) {
    var row = btn.closest('.dash-intel-insight');
    if (!row) return;
    var insightId = row.getAttribute('data-insight-id');
    if (!insightId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var dismissBtn = row.querySelector('.js-dash-insight-dismiss');
    if (dismissBtn) dismissBtn.disabled = true;

    fetch('/api/intelligence/insights/' + encodeURIComponent(insightId) + '/accept', {
        method: 'POST',
        headers: csrfHeaders()
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        return res.json();
    })
    .then(function () {
        row.classList.add('dash-intel-insight--accepted');
        row.innerHTML = '<div class="dash-intel-insight-body"><div class="dash-intel-insight-title dash-intel-insight-title--done">✓ Behavior learned</div><div class="dash-intel-insight-desc">This rule is now active and will shape future triage.</div></div>';
        toast.success('Behavior learned — your ' + getDashboardBriefNoun() + ' will adapt');
        trackEvent('insight_accepted_inline', {});
    })
    .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (dismissBtn) dismissBtn.disabled = false;
        toast.error("Couldn't save this rule. Please try again.");
    });
}

function handleDashboardInsightDismiss(btn, container) {
    var row = btn.closest('.dash-intel-insight');
    if (!row) return;
    var insightId = row.getAttribute('data-insight-id');
    if (!insightId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var acceptBtn = row.querySelector('.js-dash-insight-accept');
    if (acceptBtn) acceptBtn.disabled = true;

    fetch('/api/intelligence/insights/' + encodeURIComponent(insightId) + '/dismiss', {
        method: 'POST',
        headers: csrfHeaders()
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        row.style.transition = 'opacity 0.25s, max-height 0.3s';
        row.style.opacity = '0';
        row.style.maxHeight = '0';
        row.style.overflow = 'hidden';
        setTimeout(function () { row.remove(); }, 300);
    })
    .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (acceptBtn) acceptBtn.disabled = false;
        toast.error("Couldn't dismiss. Please try again.");
    });
}

// ── Intelligence center: learned behaviors and insights ──

function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
}

function initIntelligenceSettings() {
    var container = document.getElementById('intel-learned-rules');
    if (!container) return;

    function showSkeleton() {
        renderIntelligenceSkeletonInto(container);
    }

    function loadData() {
        showSkeleton();

        // Fetch insights (triggers lazy pattern detection) and rules in parallel
        var abortCtrl = new AbortController();
        var timeoutId = setTimeout(function () { abortCtrl.abort(); }, 15000);
        Promise.all([
            fetch('/api/intelligence/insights', { credentials: 'same-origin', signal: abortCtrl.signal }).then(function (res) {
                if (!res.ok) throw new Error();
                return res.json();
            }),
            fetch('/api/intelligence/rules', { credentials: 'same-origin', signal: abortCtrl.signal }).then(function (res) {
                if (!res.ok) throw new Error();
                return res.json();
            })
        ])
        .then(function (results) {
            clearTimeout(timeoutId);
            var insights = results[0].insights || [];
            var rules = results[1].rules || [];
            var usage = results[1].usage || {};
            var conflicts = results[1].conflicts || [];
            var signalSummary = results[1].signalSummary || {};
            renderIntelligencePanel(container, insights, rules, usage, conflicts, signalSummary);
        })
        .catch(function () {
            clearTimeout(timeoutId);
            container.innerHTML =
                '<div class="settings-intel-empty">' +
                    '<p>Could not load learned behaviors.</p>' +
                    '<button type="button" class="btn btn-sm btn-outline js-intel-retry" style="margin-top:0.5rem">Retry</button>' +
                '</div>';
        });
    }

    loadData();

    // Delegated handlers for rule and insight actions
    container.addEventListener('click', function (e) {
        var retryBtn = e.target.closest('.js-intel-retry');
        if (retryBtn) {
            loadData();
            return;
        }
        var pauseBtn = e.target.closest('.js-intel-rule-pause');
        if (pauseBtn) {
            handleRuleToggle(pauseBtn, container);
            return;
        }
        var deleteBtn = e.target.closest('.js-intel-rule-delete');
        if (deleteBtn) {
            handleRuleDelete(deleteBtn, container);
            return;
        }
        var acceptBtn = e.target.closest('.js-intel-insight-accept');
        if (acceptBtn) {
            handleInsightAccept(acceptBtn, container);
            return;
        }
        var dismissBtn = e.target.closest('.js-intel-insight-dismiss');
        if (dismissBtn) {
            handleInsightDismiss(dismissBtn, container);
            return;
        }
    });
}

function renderIntelligencePanel(container, insights, rules, usage, conflicts, signalSummary) {
    var html = '';

    // Conflict warnings (if any)
    if (conflicts && conflicts.length > 0) {
        html += '<div class="settings-intel-conflicts">';
        conflicts.forEach(function (c) {
            html += '<div class="settings-intel-conflict">' +
                '<svg class="settings-intel-conflict-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' +
                '<span class="settings-intel-conflict-text">' + escapeHtml(c.conflictDescription) + '</span>' +
            '</div>';
        });
        html += '</div>';
    }

    // Insights section (if any)
    if (insights.length > 0) {
        html += '<div class="settings-intel-insights-section">' +
            '<span class="settings-card-kicker">Patterns we noticed</span>' +
            '<div class="settings-intel-insights-list">';

        insights.forEach(function (insight) {
            var colorClass = insight.actionColor === 'green' ? 'settings-intel-insight--green' : insight.actionColor === 'red' ? 'settings-intel-insight--red' : 'settings-intel-insight--amber';
            var actionLabel = insight.suggestedAction === 'prioritize' ? 'Accept' : insight.suggestedAction === 'mute' ? 'Mute' : 'Accept';
            html += '<div class="settings-intel-insight ' + colorClass + '" data-insight-id="' + escapeAttr(insight.insightId) + '">' +
                '<div class="settings-intel-insight-body">' +
                    '<div class="settings-intel-insight-title">' + escapeHtml(insight.title) + '</div>' +
                    '<div class="settings-intel-insight-desc">' + escapeHtml(insight.description) +
                        ' <span class="settings-intel-insight-meta">' + insight.signalCount + ' signals · ' + insight.confidencePercent + '%</span>' +
                    '</div>' +
                '</div>' +
                '<div class="settings-intel-insight-actions">' +
                    '<button type="button" class="settings-intel-insight-btn settings-intel-insight-btn--accept js-intel-insight-accept">' + actionLabel + '</button>' +
                    '<button type="button" class="settings-intel-insight-btn settings-intel-insight-btn--dismiss js-intel-insight-dismiss">Dismiss</button>' +
                '</div>' +
            '</div>';
        });

        html += '</div></div>';
    }

    // Rules section
    renderLearnedRulesInto(container, html, rules, usage, signalSummary);
}

function renderLearnedRulesInto(container, prefixHtml, rules, usage, signalSummary) {
    if (rules.length === 0 && !prefixHtml) {
        var signalTotal = (signalSummary && signalSummary.total) || 0;
        var signalRecent = (signalSummary && signalSummary.last30Days) || 0;
        var usageText = usage.isUnlimited
            ? 'Unlimited rules available'
            : (usage.activeCount || 0) + ' of ' + (usage.limit || 0) + ' rules used';
        container.innerHTML =
            '<div class="settings-intel-empty">' +
                '<div class="settings-intel-empty-how">' +
                    '<p class="settings-intel-empty-heading">How learning works</p>' +
                    '<div class="settings-intel-empty-steps">' +
                        '<div class="settings-intel-empty-step">' +
                            '<svg class="settings-intel-empty-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8V21H3V8"/><path d="M1 3h22v5H1z"/><path d="M10 12h4"/></svg>' +
                            '<span>Archive items and give feedback</span>' +
                        '</div>' +
                        '<svg class="settings-intel-empty-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
                        '<div class="settings-intel-empty-step">' +
                            '<svg class="settings-intel-empty-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z"/><line x1="10" y1="22" x2="14" y2="22"/></svg>' +
                            '<span>Stackora detects patterns</span>' +
                        '</div>' +
                        '<svg class="settings-intel-empty-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
                        '<div class="settings-intel-empty-step">' +
                            '<svg class="settings-intel-empty-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
                            '<span>Suggestions appear here for you to review</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                (signalTotal > 0
                    ? '<p class="settings-intel-empty-progress">' + signalTotal + ' signals recorded' + (signalRecent > 0 ? ' (' + signalRecent + ' in the last 30 days)' : '') + '</p>'
                    : '') +
                '<p class="settings-intel-usage" style="margin-top:0.5rem">' + escapeHtml(usageText) + '</p>' +
            '</div>';
        return;
    }

    var html = prefixHtml || '';

    if (rules.length > 0) {
        var usageHtml = '';
        if (usage.isUnlimited) {
            usageHtml = '<span class="settings-intel-usage"><strong>' + (usage.activeCount || 0) + '</strong> active rules (unlimited)</span>';
        } else {
            usageHtml = '<span class="settings-intel-usage"><strong>' + (usage.activeCount || 0) + '</strong> of <strong>' + (usage.limit || 0) + '</strong> rules used</span>';
        }

        html += '<div class="settings-intel-header">' +
            '<span class="settings-card-kicker">Learned behaviors</span>' +
            usageHtml +
        '</div><div class="settings-intel-list">';

        rules.forEach(function (rule) {
        var isPaused = rule.status === 'paused';
        var isStale = rule.isStale;
        var isAutoPaused = rule.autoPaused;
        var actionIcon = getActionIcon(rule.action);
        var sourceLabel = rule.source === 'autolearned' ? 'Auto-learned' : rule.source === 'patternconfirmed' ? 'Pattern confirmed' : rule.source === 'usercreated' ? 'Created by you' : 'Manual';
        var meta = sourceLabel + ' · ' + rule.signalCount + ' signals';

        // Confidence bar level class
        var ec = rule.effectiveConfidencePercent || rule.confidencePercent || 0;
        var confidenceClass = ec >= 70 ? 'settings-intel-confidence--high' : ec >= 30 ? 'settings-intel-confidence--mid' : 'settings-intel-confidence--low';

        // Activity indicator
        var activityText = rule.lastMatchedRelative ? 'Active ' + rule.lastMatchedRelative : 'Not yet matched';

        var ruleClasses = 'settings-intel-rule';
        if (isPaused) ruleClasses += ' settings-intel-rule--paused';
        if (isStale && !isPaused) ruleClasses += ' settings-intel-rule--stale';

        html += '<div class="' + ruleClasses + '" data-rule-id="' + escapeAttr(rule.ruleId) + '" data-status="' + escapeAttr(rule.status) + '">' +
            '<div class="settings-intel-rule-icon">' + actionIcon + '</div>' +
            '<div class="settings-intel-rule-body">' +
                '<div class="settings-intel-rule-desc">' + escapeHtml(rule.description) +
                    (isAutoPaused ? ' <span class="settings-intel-rule-badge settings-intel-rule-badge--auto">Auto-paused</span>' : '') +
                    (isStale && !isPaused ? ' <span class="settings-intel-rule-badge settings-intel-rule-badge--stale">Fading</span>' : '') +
                '</div>' +
                '<div class="settings-intel-rule-meta">' +
                    '<span>' + escapeHtml(meta) + '</span>' +
                    '<span class="settings-intel-rule-activity">' + escapeHtml(activityText) + '</span>' +
                '</div>' +
                '<div class="settings-intel-rule-confidence" role="meter" aria-valuenow="' + ec + '" aria-valuemin="0" aria-valuemax="100" aria-label="Effective confidence: ' + ec + '%">' +
                    '<div class="settings-intel-rule-confidence-bar ' + confidenceClass + '" style="width:' + ec + '%"></div>' +
                '</div>' +
            '</div>' +
            '<div class="settings-intel-rule-actions">' +
                '<button type="button" class="settings-intel-rule-btn js-intel-rule-pause" title="' + (isPaused ? 'Resume' : 'Pause') + '" aria-label="' + (isPaused ? 'Resume rule' : 'Pause rule') + '">' +
                    (isPaused
                        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>'
                        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>'
                    ) +
                '</button>' +
                '<button type="button" class="settings-intel-rule-btn settings-intel-rule-btn--delete js-intel-rule-delete" title="Delete rule" aria-label="Delete rule">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
                '</button>' +
            '</div>' +
        '</div>';
    });

        html += '</div>';
    }

    container.innerHTML = html;
}

function getActionIcon(action) {
    switch (action) {
        case 'prioritize':
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l2.35 4.76 5.26.77-3.8 3.7.9 5.23L12 15.6 7.29 17.46l.9-5.23-3.8-3.7 5.26-.77L12 3z"/></svg>';
        case 'deprioritize':
        case 'mute':
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h18"/><path d="M8 7h8"/><path d="M8 17h8"/></svg>';
        case 'tag':
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
        default:
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/></svg>';
    }
}

function escapeAttr(str) {
    // Single quotes are escaped too. Every current call site uses double-quoted attributes, so
    // this changes nothing today (&#39; renders as ') — but it means a future single-quoted
    // attribute can't silently become an injection point.
    return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function renderIntelligenceSkeletonInto(el) {
    el.innerHTML =
        '<div class="settings-intel-skeleton" aria-busy="true" aria-label="Loading learned behaviors">' +
            '<div class="settings-intel-skeleton-row">' +
                '<div class="settings-intel-skeleton-icon"></div>' +
                '<div class="settings-intel-skeleton-body">' +
                    '<div class="settings-intel-skeleton-line" style="width:70%"></div>' +
                    '<div class="settings-intel-skeleton-line settings-intel-skeleton-line--short" style="width:40%"></div>' +
                '</div>' +
            '</div>' +
            '<div class="settings-intel-skeleton-row">' +
                '<div class="settings-intel-skeleton-icon"></div>' +
                '<div class="settings-intel-skeleton-body">' +
                    '<div class="settings-intel-skeleton-line" style="width:55%"></div>' +
                    '<div class="settings-intel-skeleton-line settings-intel-skeleton-line--short" style="width:35%"></div>' +
                '</div>' +
            '</div>' +
        '</div>';
}

function refreshIntelligencePanel(container) {
    renderIntelligenceSkeletonInto(container);
    Promise.all([
        fetch('/api/intelligence/insights', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { insights: [] }; }),
        fetch('/api/intelligence/rules', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { rules: [], usage: {}, conflicts: [], signalSummary: {} }; })
    ])
    .then(function (results) {
        renderIntelligencePanel(container, results[0].insights || [], results[1].rules || [], results[1].usage || {}, results[1].conflicts || [], results[1].signalSummary || {});
    });
}

function handleRuleToggle(btn, container) {
    var row = btn.closest('.settings-intel-rule');
    if (!row) return;
    var ruleId = row.getAttribute('data-rule-id');
    var currentStatus = row.getAttribute('data-status');
    var newStatus = currentStatus === 'paused' ? 'active' : 'paused';

    btn.disabled = true;
    fetch('/api/intelligence/rules/' + encodeURIComponent(ruleId), {
        method: 'PUT',
        headers: csrfHeaders(),
        body: JSON.stringify({ status: newStatus })
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        refreshIntelligencePanel(container);
    })
    .catch(function () {
        btn.disabled = false;
        toast.error("Couldn't update rule. Please try again.");
    });
}

function handleRuleDelete(btn, container) {
    var row = btn.closest('.settings-intel-rule');
    if (!row) return;
    var ruleId = row.getAttribute('data-rule-id');

    btn.disabled = true;
    fetch('/api/intelligence/rules/' + encodeURIComponent(ruleId), {
        method: 'DELETE',
        headers: csrfHeaders()
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        refreshIntelligencePanel(container);
        toast.success('Rule removed');
    })
    .catch(function () {
        btn.disabled = false;
        toast.error("Couldn't delete rule. Please try again.");
    });
}

function handleInsightAccept(btn, container) {
    var row = btn.closest('.settings-intel-insight');
    if (!row) return;
    var insightId = row.getAttribute('data-insight-id');
    if (!insightId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var dismissBtn = row.querySelector('.js-intel-insight-dismiss');
    if (dismissBtn) dismissBtn.disabled = true;

    fetch('/api/intelligence/insights/' + encodeURIComponent(insightId) + '/accept', {
        method: 'POST',
        headers: csrfHeaders()
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        return res.json();
    })
    .then(function () {
        toast.success('Behavior learned');
        refreshIntelligencePanel(container);
    })
    .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (dismissBtn) dismissBtn.disabled = false;
        toast.error("Couldn't save this rule. Please try again.");
    });
}

function handleInsightDismiss(btn, container) {
    var row = btn.closest('.settings-intel-insight');
    if (!row) return;
    var insightId = row.getAttribute('data-insight-id');
    if (!insightId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var acceptBtn = row.querySelector('.js-intel-insight-accept');
    if (acceptBtn) acceptBtn.disabled = true;

    fetch('/api/intelligence/insights/' + encodeURIComponent(insightId) + '/dismiss', {
        method: 'POST',
        headers: csrfHeaders()
    })
    .then(function (res) {
        if (!res.ok) throw new Error();
        refreshIntelligencePanel(container);
    })
    .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (acceptBtn) acceptBtn.disabled = false;
        toast.error("Couldn't dismiss. Please try again.");
    });
}

// ── Subscription banner dismiss ──
function initSubscriptionBanner() {
    var banner = document.querySelector('[data-sub-banner-variant]');
    if (!banner) return;

    var variant = banner.getAttribute('data-sub-banner-variant') || '';
    var planId = banner.getAttribute('data-sub-banner-plan') || '';
    var dismissKey = banner.getAttribute('data-sub-banner-dismiss-key');

    // Check if dismissed recently (7-day re-show cycle)
    if (dismissKey) {
        var dismissedAt = null;
        try { dismissedAt = localStorage.getItem(dismissKey); } catch (_) { /* private browsing */ }
        if (dismissedAt) {
            var elapsed = Date.now() - parseInt(dismissedAt, 10);
            if (elapsed < 7 * 24 * 60 * 60 * 1000) {
                banner.hidden = true;
                return;
            }
            try { localStorage.removeItem(dismissKey); } catch (_) { /* */ }
        }
    }

    // Track impression (once per session per variant+plan combination)
    var impressionKey = 'sub_banner_shown_' + variant + '_' + planId;
    var alreadyTracked = false;
    try { alreadyTracked = !!sessionStorage.getItem(impressionKey); } catch (_) { /* */ }
    if (!alreadyTracked) {
        trackEvent('sub_banner_shown', { variant: variant, plan_id: planId });
        try { sessionStorage.setItem(impressionKey, '1'); } catch (_) { /* */ }
    }

    // Track CTA click
    var cta = banner.querySelector('.sub-banner-cta');
    if (cta) {
        cta.addEventListener('click', function () {
            trackEvent('sub_banner_cta_click', { variant: variant, plan_id: planId });
        });
    }

    // Track dismiss
    var closeBtn = banner.querySelector('[data-sub-banner-close]');
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            banner.hidden = true;
            trackEvent('sub_banner_dismissed', { variant: variant, plan_id: planId });
            if (dismissKey) {
                try { localStorage.setItem(dismissKey, String(Date.now())); } catch (_) { /* */ }
            }
        });
    }
}

function initUpgradeNudges() {
    document.querySelectorAll('[data-upgrade-nudge]').forEach(function (nudge) {
        var key = nudge.getAttribute('data-upgrade-nudge');
        if (!key) return;

        // Track CTA click
        var cta = nudge.querySelector('.upgrade-nudge-btn');
        if (cta) {
            cta.addEventListener('click', function () {
                trackEvent('upgrade_nudge_click', { nudge_key: key, page_path: window.location.pathname, page_title: document.title });
            });
        }

        // Dismiss
        var dismissBtn = nudge.querySelector('[data-upgrade-nudge-dismiss]');
        if (dismissBtn) {
            dismissBtn.addEventListener('click', function () {
                nudge.hidden = true;
                trackEvent('upgrade_nudge_dismissed', { nudge_key: key, page_path: window.location.pathname, page_title: document.title });
                try { localStorage.setItem(key, String(Date.now())); } catch (_) { /* */ }
            });
        }
    });
}

function initSiteUi() {
    initSubscriptionBanner();
    initUpgradeNudges();
    initWebVitalsTelemetry();
    initSignInTracking();
    initFormEventTracking();
    bindSupportOverlay();
    bindDeleteAccountOverlay();
    bindDataExportTracking();
    initSettingsAjaxForms();
    initDigestTimeSnapping();
    initAutoSubmitToggles();
    initCalendarTestButtons();
    initSubscriptionSettings();
    initDashboardUi();
    initDashboardSearch();
    initActionItemsUi();
    initAnalyticsTracking();
    initIntelligenceSettings();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiteUi);
} else {
    initSiteUi();
}
